import { React, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, IconButton, TextField, Tooltip, Popover, Dialog } from '@material-ui/core';
import { Storage } from 'aws-amplify';
import moment from 'moment';
import Utils, { isDisableApproveRejectAnonymousQaTicket } from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { deleteAllTicketData, getTicketDetailAPI, sentTicketFromDraft } from '@/service/ticketService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorMessageHeader from '../common/ErrorMessageHeader';
import '../common/ErrorMessageHeader.css';
import './ChatThread.css';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
    closePanelTabSelector,
    setPanelSelector,
    triggerReloadTab,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { getUserListByProjectAtom, userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import { projectIdListUserIsB2CAtom, projectInuseDetailAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import {
    handleArchiveTicket,
    isShowInvitationStatus,
    isShowInvitationExternalHeader,
    onClickApproveRejectExternal,
    onSubmitApproveExternalDeskRequest,
    updateTabNameAfterEditTicket,
    submitUpdateTicket,
    handleEditTicketWhenSentFromDraft,
    rejectAnonymousQaTicket,
    approveAnonymousQaTicket,
    onSubmitApproveExternalCustomerRequest,
    isDisplayIconChat,
    showUpdatorDetailTicket,
    getTitle,
    isDisplayIconKnowledge,
    submitSoftDeleteTicket,
    submitRestoreAnonymousTicket,
    handleBackToArrivalTicket,
    handlerShowButtonEditTicket,
    handleDeleteCompleteTicketLiveChat,
    isDisableButtonCompleteDeleteTicket,
    isDisplayButtonCompleteDeleteTicket,
    isShowInvitationGuestOrGuestDeskStatus,
    isDisableButtonSoftDeleteTicketQAAnonymos,
    isInputAllFieldRequiredWhenEditTicket,
    renderUserName,
    getTelephoneStatusFromTicket,
    getHamburgerMenuOptionsForTelephone
} from './handler/DetailTicketHandler';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { FormProvider, useForm } from 'react-hook-form';
import CustomSchema from '@/schema/CustomSchema';
import { yupResolver } from '@hookform/resolvers';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import { API, I18n } from 'aws-amplify';
import { bulkCreateTagItem } from '@/service/formManagementService';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { closeTabId, lastActivePanelIdAtom, multiPanelAtom, panelInitDataAtom, reloadChatThreadPanelAtom, triggerReloadMenuAtom } from '@/state/atom/panelAtom';
import { DialogConfirmCancelEditTicket } from './editTicketDialog/DialogConfirmCancelEditTicket';
import _, { cloneDeep } from 'lodash';
import { DialogConfirmRejectAnonymousQaTicket } from '../ticketList/listTicketDialog/DialogConfirmRejectAnonymousQaTicket';
import { DialogConfirmAcceptAnonymousQaTicket } from '../ticketList/listTicketDialog/DialogConfirmAcceptAnonymousQaTicket';
import { DialogNotificationTicketApprovedBefore } from '../ticketList/listTicketDialog/DialogNotificationTicketApprovedBefore';
import StatusFieldUI from '../formManagement/fieldUI/StatusFieldUI';
import TelephoneCallStatusFieldUI from '../formManagement/fieldUI/TelephoneCallStatusFieldUI';
import { ConfirmForceEditTicket } from './editTicketDialog/ConfirmForceEditTicket';
import { canTicketHasPIC, canTicketHasStatus, getAssignList, onSubmitApproveAnonymousQaFromLiveChat } from '../ticketList/handler/TicketListHandler';
import AssigneeUI from '../formManagement/fieldUI/AssigneeFieldUI';
import AssigneeFieldCommonUI from '../formManagement/fieldUI/AssigneeFieldCommonUI';
import { useSnackbar } from 'notistack';
import { DialogConfirmApproveRejectTicket } from './editTicketDialog/DialogConfirmApproveRejectTicket';
import { DialogConfirmCreateTicketError } from '../ticketList/addTicketDialog/DialogConfirmCreateTicketError';
import { DialogConfirmChangeTicketError } from '../ticketList/addTicketDialog/DialogConfirmChangeTicketError';
import {TmpHiddenSysFieldInTicketDetail} from '@/common/constant/SystemField'
import { getPanelInitData, removePanelInitData, updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { initDataPanelDetailTicket } from './handler/DetailTicketPanelHandler';
import {
    isDisableApproveRejectAnonymousQaFromLiveChat,
    isTicketCountNumber, updateLimitNumOfTicket,
    closePanelTabDetailTicket,
    isDisableCallBackButton
} from '../ticketList/handler/TicketHandler';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { DialogConfirmSoftDeleteTicket } from '../ticketList/listTicketDialog/DialogConfirmSoftDeleteTicket';
import ConfirmDialog from '../../common/dialog/ConfirmDialog';
import { checkDetailTicket } from '../../service/ticketService';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import {showLoadingMouse, hideLoadingMouse} from '../../common/utils/CustomCursor';
import { getCorporationDetailByCorporationDomain } from '@/service/organizationService';
import { getProjectById } from '@/service/projectService';
import { getUserById } from '@/service/userService';
import Logger from '@/common/utils/Logger';
import FieldInvitedPartnerB2b from '../ticketList/customerSide/FieldInvitedPartnerB2b';
import { getProjectMemberList } from '../ticketList/handler/HelpDeskTicketListHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation, formatViewTicketTaskLogKibana } from '../system/logKibanaHandler/LogKibanaHandler';
import { helpdeskTicketLastUserActionAtom, isShowVisibilityKnowledgeAtom, triggerReLoadHelpdeskTicketDetailAtom } from '@/state/atom/ticketAtom';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { openShareLinkTicket } from './handler/MessageHandler';
import { signOut } from '@/service/authenService';
import { getCorporationById } from '@/service/organizationService';
import TagDefaultBookmark from '../ticketKnowledge/elements/Bookmark/TagDefaultBookmark';
import Bookmark from '../ticketKnowledge/elements/Bookmark/Bookmark';
import UserTagPrivateBookmarkCount from '../ticketKnowledge/elements/Bookmark/UserTagPrivateBookmarkCount';
import TaggedBookmarkListName from '../ticketKnowledge/elements/Bookmark/TaggedBookmarkListName';
import CopyShortLink  from '@/component/ticketKnowledge/elements/CopyShortLink';
import { PropTypes } from 'prop-types';
import { ButtonOption, FlagMessageCopyLink } from '../ticketList/DetailTicketList';
import AttachFileChatPost from '../attachFile/AttachFileChatPost';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import { useOutboundCall } from '@/hooks/useOutboundCall';
import { hasEditPermissionWithSpecialCase } from '../ticketKnowledge/handler/DetailTicketHandler';
import { validateTelephonePermission } from '@/service/phoneContactService';
import { voiceStatusAtom } from '@/state/atom/voiceCallAtom';
import { isVoiceCallTicketAvailableInProject, resolveVoiceCallTarget, resolveVoiceCallTargetName } from '../ticketList/handler/TelephoneVoiceCallHandler';
import { openTelephoneTicketPanel } from '@/component/telephoneAgent/handler/TelephoneTicketPanelHandler';

DetailTicket.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    panelType: PropTypes.any,
    triggerReload: PropTypes.any,
    API: PropTypes.any,
    ticketListType: PropTypes.any
};

export default function DetailTicket(props) {
    const { enqueueSnackbar } = useSnackbar();
    const currentProjectId = localStorageUtil.getSelectedProjectId();
    
    // panel state
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    const setTriggerReloadMenu = useSetRecoilState(triggerReloadMenuAtom);
    const [reloadChatThread ,setReloadChatThread] = useRecoilState(reloadChatThreadPanelAtom);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);

    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);

    const [isExChangeTagField, setIsExChangeTagField] = useState(false)
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const [detailTicket, setDetailTicket] = useState({});
    const [listTicketChild, setListTicketChild] = useState([]);
    const [ticketParent, setTicketParent] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [listFieldData, setListFieldData] = useState([]);
    const [isDisplayTicketParent, setIsDisplayTicketParent] = useState(true);
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const projectIdListUserIsB2C = useRecoilValue(projectIdListUserIsB2CAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    
    const [hasEditPermission, setHasEditPermission] = useState(false);
    const [selectedProject, setSelectedProject] = useRecoilState(projectInuseDetailAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isEdited,setIsEdited ] = useState(false);
    const [onChangeEdit,setOnChangeEdit] = useState(false);
    const isGeneralUser = Utils.isGeneralUserWithoutGuest(currentUserDetail);
    const isGeneralUserWithGuest = Utils.isGeneralUser(currentUserDetail);
    const [autoFillObject, setAutoFillObject] = useState({});
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [isDisplayEditTicket, setIsDisplayEditTicket] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [mapDataIdToId, setMapDataIdToId] = useState({});
    const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false);
    const [isApprovedExternalDeskRequest, setIsApprovedExternalDeskRequest] = useState(false);
    const [isApprovedExternalCustomerRequest, setIsApprovedExternalCustomerRequest] = useState(false);
    const [formDetail, setFormDetail] = useState({});
    
    const [isAnonymousQAWaitingTicket, setIsAnonymousQAWaitingTicket] = useState(false);
    const [isConfirmRejectTicket, setIsConfirmRejectTicket] = useState(false);
    const [isConfirmAcceptTicket, setIsConfirmAcceptTicket] = useState(false);
    const [isOpenModalApproveRejectError, setIsOpenModalApproveRejectError] = useState(false);
    const [isOpenPopupEditError, setIsOpenPopupEditError] = useState(false);
    const [triggerReloadTicket, setTriggerReloadTicket] = useState(0);
    const [isTicketUpdatedBefore, setIsTicketUpdatedBefore] = useState(false);
    const [approvalFlagAfterUpdated, setApprovalFlagAfterUpdated] = useState();
    const [statusOfTicket, setStatusOfTicket] = useState({})
    const [telephoneStatusOfTicket, setTelephoneStatusOfTicket] = useState({})
    const [newStatusOfTicket,setNewStatusOfTicket] = useState('')
    const [newStatusData,setNewStatusData] = useState({})
    const [forceEditTicketObject, setForceEditTicketObject] = useState({
        method: 0,
        requestDto: {}
    });
    let userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const [projectUserList, setProjectUserList] = useState([]);
    const [currentAssigneeUserData, setCurrentAssigneeUserData] = useState({});
    const [newAssignData,setNewAssigneeData] = useState({})
    const [newAssignee, setNewAssignee] = useState('');
    const [listFieldEdited, setListFieldEdited] = useState([])

    // Approve/reject external customer request
    const [selectedApproveFlag, setSelectedApproveFlag] = useState('');
    const [isOpenPopupConfirmApproveRejectCustomerRequest, setIsOpenPopupConfirmApproveRejectCustomerRequest] = useState(false);
    const [isOpenPopupConfirmApproveRejectDeskRequest, setIsOpenPopupConfirmApproveRejectDeskRequest] = useState(false);
    const [isOpenPopupApproveRejectError, setIsOpenPopupApproveRejectError] = useState(false);
    const [isOpenPopupSoftDelete, setIsOpenPopupSoftDelete] = useState(false);
    const [isHelpDesk, setIsHelpDesk] = useState(false)
    const [flagReset,setFlagReset] = useState(false);

    const [viewFromProjectOfEscalateTicket, setViewFromProjectOfEscalateTicket] = useState(false)

    const [isMe, setIsMe] = useState(false);
    const [errorMessageHeader, setErrorMessageHeader] = useState('');

    const [isSoftDelete, setIsSoftDelete] = useState(false);
    const [isRejectTicketAnonymous, setIsRejectTicketAnonymous] = useState(false);
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);
    const [isConfirmDialogObj, setIsConfirmDialogObj] = useState(false);
    const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const [isOpenPopupTicketMsg, setIsOpenPopupTicketMsg] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [contentModalReloadPage, setContentModalReloadPage] = useState('');
    const [isDisableEdit, setIsDisableEdit] = useState(false);
    const [isDisableDeskService, setIsDisableDeskService] = useState(0);
    const [isShowDialogBackToArrivalTicket, setIsShowDialogBackToArrivalTicket] = useState(false);
    const [isTagList, setIsTagList] = useState(false);
    const [tagListValue, setTagListValue] = useState([]);
    const [isEditTicket, setIsEditTicket ] = useState(false);
    const [isShowDialogDeleteTicketFromLiveChat, setIsShowDialogDeleteTicketFromLiveChat] = useState(false);
    const [titleLineNumber, setSettingTitleLineNumber] = useState(0);
    const setIsShowVisibilityKnowledgeAtom = useSetRecoilState(isShowVisibilityKnowledgeAtom);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [corporationAffiliationTicket, setCorporationAffiliationTicket] = useState({});
    const [anchorShowMoreActionsPopover, setAnchorShowMoreActionsPopover] = useState(null);
    const [displayPopupConfirmCancel, setDisplayPopupConfirmCancel] = useState(false);
    const [displayMode, setDisplayMode] = useState(Constant.DISPLAY_MODE.VIEW);
    const [telephoneFromName, setTelephoneFromName] = useState('');
    // useOutboundCall hook cho callback button
    const { initiateCall } = useOutboundCall();
    const voiceStatus = useRecoilValue(voiceStatusAtom);
    
    const isOpenShowMoreOptionsPopover = useMemo(() => {
        return Boolean(anchorShowMoreActionsPopover) || false;
    }, [anchorShowMoreActionsPopover]);

    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);

    const isQAPanel = useMemo(() => {
        return [
            Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST,
            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        ].includes(props?.panelType);
    }, [props?.panelType]);

    // Telephone call status cho telephone ticket
    const telephoneCallStatus = useMemo(() => {
        try {
            if (detailTicket.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
                return null;
            }
            return getTelephoneStatusFromTicket(detailTicket);
        } catch (error) {
            console.error('Error getting telephone call status:', error);
            return null;
        }
    }, [detailTicket]);

    // Determine whether it is a Helpdesk panel
    const isHelpdeskPanel = useMemo(() => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return false;
        let currentPanel = panelList[currentPanelIndex];
        const panelType = currentPanel?.type;
        return (
            panelType &&
            panelType.toLowerCase().startsWith(Constant.DEFINITION_VIEW.HELPDESK.toLowerCase())
        );
    }, [props.panelId, panelList]);

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);
        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            selectedProject.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setSelectedProject,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    let isMounted = true;

    let argsAll = {
        ...props,
        API: props?.API,
        panelId: props.panelId,
        corporationDetail,
        setCorporationDetail,
        detailTicket,
        setDetailTicket,

        isLoading,
        setIsLoading,

        currentUserDetail,
        isProjectManager,
        selectedProject,
        isGeneralUser,

        isApprovedExternalDeskRequest,
        isApprovedExternalCustomerRequest,
   
        panelList,
        setPanelList,

        fieldListDefaultData,
        setFieldListDefaultData,
        isEdited,
        setIsEdited,
        isDisplayEditTicket,
        setIsDisplayEditTicket,
        fileUploadList,
        setFileUploadList,
        fileUpdatedList,
        fileUploading,
        setFileUploading,
        mapDataIdToId,
        setMapDataIdToId,
        isConfirmRejectTicket,
        setIsConfirmRejectTicket,
        isConfirmAcceptTicket,
        setIsConfirmAcceptTicket,
        reloadTicketListByPanelType,
        closePanelTab,
        isOpenModalApproveRejectError,
        setIsOpenModalApproveRejectError,
        triggerReloadTicket,
        setTriggerReloadTicket,
        isTicketUpdatedBefore,
        setIsTicketUpdatedBefore,
        approvalFlagAfterUpdated,
        setApprovalFlagAfterUpdated,
        newStatusOfTicket,
        statusOfTicket,
        setForceEditTicketObject,
        forceEditTicketObject,
        userListRecoilValue,
        setProjectUserList,
        projectUserList,
        currentAssigneeUserData,
        setCurrentAssigneeUserData,
        isMe, 
        setIsMe,
        setNewAssignee,
        newAssignee,
        isAnonymousQAWaitingTicket,
        enqueueSnackbar,
        selectedApproveFlag,
        setSelectedApproveFlag,
        isOpenPopupConfirmApproveRejectCustomerRequest,
        setIsOpenPopupConfirmApproveRejectCustomerRequest,
        isOpenPopupApproveRejectError,
        setIsOpenPopupApproveRejectError,
        listFieldEdited,
        setListFieldEdited,
        formDetail,
        isHelpDesk,
        viewFromProjectOfEscalateTicket,
        isOpenPopupConfirmApproveRejectDeskRequest,
        setIsOpenPopupConfirmApproveRejectDeskRequest,
        panelInitData, 
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        flagReset,
        setFlagReset,
        reloadChatThread,
        setReloadChatThread,
        isShowDialogRestoreTicket,
        setIsShowDialogRestoreTicket,
        isRejectTicketAnonymous,
        isSoftDelete,
        isConfirmDialogObj,
        setIsConfirmDialogObj,
        isOpenPopupTicketError, 
        setIsOpenPopupTicketError,
        isOpenPopupTicketMsg,
        setIsOpenPopupTicketMsg,
        setIsOpenModalReloadPage,
        isOpenModalReloadPage,
        isDisableEdit,
        setFileUpdatedList,
        setIsOpenPopupEditError,
        isTagList,
        setIsTagList,
        tagListValue,
        setTagListValue,
        isEditTicket,
        setIsEditTicket,
        reloadPanelAfterSoftDeleteTicketByPanelType,
        newStatusData,
        userPermissionView,
        setIsShowPopupLogout
    };

    const validateEditTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListDefaultData))
    });
    const handleSubmitEditTicket = validateEditTicket.handleSubmit;
    const errorEditTicket = validateEditTicket.errors;
    const clearErrors = validateEditTicket.clearErrors;
    const setValueEditTicket = validateEditTicket.setValue;
    const registerEditTicket = validateEditTicket.register;
    const getValuesEditTicket = validateEditTicket.getValues;
    const setErorsEditTicket = validateEditTicket.setError;
    const triggerValidate = validateEditTicket.trigger;

    const [outline,setOutLine] = useState('');
    const [assignList, setAssignList] = useState([]);
    const [evaluatorUserNameMap, setEvaluatorUserNameMap] = useState({});
    const [settingTitle, setSettingTitle] = useState([]);
    const [projectDetails, setProjectDetails] = useState(selectedProject);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });

    const [triggerReLoadHelpdeskTicketDetail, setTriggerReLoadHelpdeskTicketDetail] = useRecoilState(
        triggerReLoadHelpdeskTicketDetailAtom
    );

    const currentTabData = useMemo(() => {
        const panel = panelInitData.find(p => p.id === props.panelId);
        if (!panel) return;
        const tab = (panel?.tabList || []).find(t => t.id === props.tabId)?.data;
        return tab
    }, [panelInitData, props.tabId, props.panelId]);

    useEffect(()=>{
        if (isEdited && detailTicket.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
             const formEditValue  = getValuesEditTicket();
             let newTitle = ''
             
             settingTitle?.forEach((element) =>{
                if(!Utils.isEmptyString(element.id)){
                   const fieldDetail = fieldListDefaultData?.find(field =>{
                        return field.id === element.id || element.sysField === field.sysField
                    });
                    if (!Utils.isEmptyObject(fieldDetail)) {
                        let value = ''
                        if(fieldDetail.definition === Constant.FORM_DEFINITION.SYSTEM || fieldDetail.type === Constant.FORM_TYPE.FIELD_WORKFLOW ){
                            switch (fieldDetail.sysField) {
                                case 'attachments':
                                    fileUpdatedList?.forEach(file =>{
                                        value = value + file.fileName + ' '
                                    })
                                    fileUploadList?.forEach(file =>{
                                        value = value + file.fileName + ' '
                                    })
                                    break;
                                case 'ticketId':
                                    value = element.text
                                    break;
                                case 'ticketType':
                                    value = element.text
                                    break;
                                case 'proxiedUser':
                                    value = element.text
                                    break;
                                case 'outline':
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case 'personInCharge':
                                    value= Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.jp,newAssignData)
                                    break;
                                case 'deadline':
                                    value = element.text
                                    break;
                                default:
                                    break;
                            }
                            if(fieldDetail.type === Constant.FORM_TYPE.FIELD_WORKFLOW){
                               const status = {}
                                if(!Utils.isEmptyString(status)){
                                    value = newStatusData.name
                                }
                            }
                            if(Utils.isEmptyString(value)){
                                value = `[${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,fieldDetail.name)}(現在未記入)]`
                            }
                            newTitle = newTitle + value + ' '
                        }else{
                            
                            switch (fieldDetail.type) {
                                case Constant.FORM_TYPE.FIELD_TAG:
                                    const tagValue = formEditValue[fieldDetail.id]
                                    tagValue?.forEach((tag ,index)=>{
                                        if (index === 0) {
                                            value = tag.title;
                                        } else {
                                            value =
                                                value +
                                                `, ${tag.title
                                                }`;
                                        }
                                    }) 
                                    break;
                                case Constant.FORM_TYPE.FIELD_TEXT:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_DATE:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_DATE_TIME:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_TIME:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_INT:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_FLOAT:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.URL:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.IFRAME:
                                    value = formEditValue[fieldDetail.id]
                                    break;
                                case Constant.FORM_TYPE.FIELD_RICHTEXT:
                                    if (formEditValue.hasOwnProperty(fieldDetail.id) && formEditValue[fieldDetail.id]) {
                                        value =Utils.convertJSONDataToObject(formEditValue[fieldDetail.id])?.replace(/(<([^>]+)>)/gi, '')?.replace(/\\n/g, '').replace(/&nbsp;/g, '');
                                    }
                                    break;
                                default:
                                    break;
                            }
                            newTitle = newTitle + value + ' ' 
                        }
                    }else{
                        newTitle = newTitle + element.text + ' ' 
                    }
                }else if(!element.isBreak){
                    newTitle = newTitle + element.text + ' '
                }
            setOutLine(newTitle)
             })
        }
    },[onChangeEdit,isEdited]);

    useEffect(() => {
        clearErrors();
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'displayMode',
            displayMode
        );
    }, [displayMode]);

    useEffect(() => {
        // save listFieldEdited to panel
        if (listFieldEdited.length) {
            const newlistFieldEdited = [...new Set([ ...(currentTabData?.listFieldEdited || []), ...listFieldEdited])];
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', newlistFieldEdited);
        }
    }, [listFieldEdited]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
    }, [isEdited])

    useEffect(() => {
        if (isLoading) {
            showLoadingMouse();
        } else {
            hideLoadingMouse();
        }
    }, [isLoading]);

    const saveFormData = () => {
        let formData = getValuesEditTicket();
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'formData', formData);
    }

    useEffect(() => {
        if (lastActivePanelId && lastActivePanelId.panelId === props.panelId && isEdited) {
            saveFormData();
        }
    }, [lastActivePanelId, isEdited]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUploadList', fileUploadList);
    }, [fileUploadList])

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUpdatedList', fileUpdatedList);
        if(!Utils.isEmptyObject(currentPanelInitData) && currentPanelInitData?.hasOwnProperty('fileUpdatedList')){
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData)
            currentPanelInitDataClone.fileUpdatedList = [...fileUpdatedList]
            setCurrentPanelInitData({...currentPanelInitDataClone})
        }
    }, [fileUpdatedList])

    useEffect(() => {
        if (
            props.ticketId ||
            selectedProject ||
            props.triggerReload ||
            triggerReloadTicket ||
            triggerReLoadHelpdeskTicketDetail === props?.tabId
        ) {
            getTicketDetail(props.ticketId, false)
            getProjectMemberList(userListRecoilValue, setProjectUserList, selectedProject?.id);
            // reset form
            validateEditTicket?.reset();
            setIsEdited(false);
        }
    }, [
        props.ticketId, 
        selectedProject, 
        props.triggerReload, 
        triggerReloadTicket,
        triggerReLoadHelpdeskTicketDetail
    ]);

    useEffect(() => {
        registerEditTicket('fileUploadList');
        getProjectById(props?.API, currentProjectId).then((project) => {
            setProjectDetails(project);
        }).catch(err => {
            console.log('getProjectById error', err);
        });
        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.argsAll) {
                initDataPanelDetailTicket(currentPanelInitDataRes, argsAll);
            }
            if (currentPanelInitDataRes.isEditedData) {
                setIsEdited(true);
            }
            if (currentPanelInitDataRes.displayMode) {
                setDisplayMode(currentPanelInitDataRes.displayMode);
            }
            return;
        }

        return () => {
            setCurrentPanelInitData({});
            setIsExChangeTagField(false);
            setDetailTicket({});
            setListTicketChild([]);
            setTicketParent({});
            setIsLoading(false);
            setListFieldData([]);
            setIsDisplayTicketParent(true);
            setHasEditPermission(false);
            setFieldListDefaultData([]);
            setIsEdited(false);
            setOnChangeEdit(false);
            setAutoFillObject({});
            setIsDisplayEditTicket(false);
            setFileUploadList([]);
            setFileUpdatedList([]);
            setFileUploading({});
            setMapDataIdToId({});
            setIsConfirmCancelEditTicket(false);
            setIsApprovedExternalDeskRequest(false);
            setIsApprovedExternalCustomerRequest(false);
            setFormDetail({});
            setIsAnonymousQAWaitingTicket(false);
            setIsConfirmRejectTicket(false);
            setIsConfirmAcceptTicket(false);
            setIsOpenModalApproveRejectError(false);
            setIsOpenPopupEditError(false);
            setTriggerReloadTicket(0);
            setIsTicketUpdatedBefore(false);
            setApprovalFlagAfterUpdated();
            setStatusOfTicket({});
            setTelephoneStatusOfTicket({});
            setNewStatusOfTicket('');
            setNewStatusData({});
            setForceEditTicketObject({ method: 0, requestDto: {} });
            setProjectUserList([]);
            setCurrentAssigneeUserData({});
            setNewAssignee('');
            setListFieldEdited([]);
            setSelectedApproveFlag('');
            setIsOpenPopupConfirmApproveRejectCustomerRequest(false);
            setIsOpenPopupConfirmApproveRejectDeskRequest(false);
            setIsOpenPopupApproveRejectError(false);
            setIsOpenPopupSoftDelete(false);
            setIsHelpDesk(false);
            setFlagReset(false);
            setViewFromProjectOfEscalateTicket(false);
            setIsMe(false);
            setIsSoftDelete(false);
            setIsRejectTicketAnonymous(false);
            setIsShowDialogRestoreTicket(false);
            setIsConfirmDialogObj(false);
            setIsOpenPopupTicketError(false);
            setIsOpenPopupTicketMsg(false);
            setIsOpenModalReloadPage(false);
            setContentModalReloadPage('');
            setIsDisableEdit(false);
            setIsDisableDeskService(0);
            setIsShowDialogBackToArrivalTicket(false);
            setIsTagList(false);
            setTagListValue([]);
            setIsEditTicket(false);
            setIsShowDialogDeleteTicketFromLiveChat(false);
            setSettingTitleLineNumber(0);
            setDisplayMode(Constant.DISPLAY_MODE.VIEW);
            argsAll = {};
        }
    }, [])
    
    useEffect(() => {
        const outline = detailTicket.outline;
        if(detailTicket.affiliationProject === selectedProject.id){
            if(detailTicket.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD && props.ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER){
                setIsHelpDesk(false);
            }else{
                setIsHelpDesk(true);
            }
        }
        
        if(!Utils.isEmptyObject(detailTicket.personInChargeInfo)){
           
            setCurrentAssigneeUserData({...detailTicket.personInChargeInfo,assigneeIcon:detailTicket.personInChargeInfo.shortName,assigneeFullName:detailTicket.personInChargeInfo.fullName } )
        }else{
            
            setCurrentAssigneeUserData({}) 
        }
        setOutLine(outline)

        if (
            detailTicket.ticketType !== Constant.TICKET_TYPE.BROADCAST_PARENT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.BROADCAST_CHILD
        ) {
            if (detailTicket?.listTicketChild) {
                const listTicketChildObject = Utils.convertJSONDataToObject(detailTicket?.listTicketChild);
                const listTicketChildUndeleted = listTicketChildObject.filter(ticket => Utils.isEmptyString(ticket.deletedAt));
                setListTicketChild(listTicketChildUndeleted);
            } else {
                setListTicketChild([]);
            }
        }

        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'argsAll', newArgsAll);
    }, [detailTicket]);

    const handleCloseTab = (edited) => {
        const panelType = getPanelType();
        const closePanelParams = {
            isEdited: edited, 
            setIsOpenPopupConfirm: setIsConfirmCancelEditTicket, 
            panelType: panelType, 
            panelId: props.panelId, 
            detailTicket: detailTicket, 
            panelList: panelList, 
            closePanelTab: closePanelTab, 
            setCloseTabIdState: setCloseTabIdState,
            removePanelInitData: removePanelInitData,
            panelInitData: panelInitData,
            setPanelInitData: setPanelInitData
        }
        closePanelTabDetailTicket(closePanelParams);
    };

    // handle close tab when click icon X in tab
    useEffect(() => {
        if (
            props.tabId === closeTabIdState || (props.componentName === 'DetailTicket' && closeTabIdState === detailTicket.id)
        ) {
            handleCloseTab(isEdited)
        }
    }, [closeTabIdState]);

    useEffect(() => {
        if (!detailTicket) return;

        // -------- Parent ticket --------
        const parent = detailTicket.parentTicket
            ? Utils.convertJSONDataToObject(detailTicket.parentTicket)
            : {};

        setTicketParent(parent);

        const customer = Utils.convertJSONDataToObject(detailTicket.customersCustomer);
        const shouldDisplayParent =
            !!detailTicket.parentTicket &&
            (!!customer?.ticketQA || detailTicket.projectOrigin === selectedProject?.id);

        setIsDisplayTicketParent(shouldDisplayParent);
        setIsSoftDelete(!Utils.isEmptyString(detailTicket.deletedAt));
        setIsRejectTicketAnonymous(Utils.isAnonymousQARejectTicket(detailTicket));
    }, [detailTicket, selectedProject?.id]);

    useEffect(() => {
        setAssignList(getAssignList(projectUserList, currentUserDetail));
        return () => {
            setAssignList([]);
        };
    }, [detailTicket, projectUserList]);

    function getEvaluatorSelectionMeta(value) {
        const parsedValue = Utils.convertJSONDataToObject(value);
        if (!Array.isArray(parsedValue) || Utils.isEmptyArray(parsedValue)) {
            return null;
        }

        const selectedItem = parsedValue[0];
        if (typeof selectedItem === 'string') {
            return {
                id: selectedItem,
                label: selectedItem
            };
        }

        if (Utils.isEmptyObject(selectedItem)) {
            return null;
        }

        const id = selectedItem?.value || selectedItem?.id || '';
        if (Utils.isEmptyString(id)) {
            return null;
        }

        return {
            id,
            label: selectedItem?.title || selectedItem?.fullName || id
        };
    }

    const fetchedEvaluatorRef = useRef({});

    const evaluatorUserId = useMemo(() => {
        if (Utils.isEmptyArray(fieldListDefaultData)) return '';
        const evaluatorField = fieldListDefaultData.find(
            field => field?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.EVALUATOR
        );
        if (!evaluatorField) return '';
        const evaluatorMeta = getEvaluatorSelectionMeta(
            evaluatorField.defaultValue || evaluatorField.value
        );
        return evaluatorMeta?.id || '';
    }, [fieldListDefaultData]);

    useEffect(() => {
        let cancelled = false;

        const loadEvaluatorDisplayName = async () => {
            try {
                if (
                    Utils.isEmptyString(evaluatorUserId) ||
                    Utils.getPrefixOfId(evaluatorUserId) !== Constant.ID_PREFIX.USER
                ) {
                    return;
                }
                if (fetchedEvaluatorRef.current[evaluatorUserId]) return;
                fetchedEvaluatorRef.current[evaluatorUserId] = true;

                const evaluatorUserInfo = await getUserById(null, evaluatorUserId);
                if (cancelled || Utils.isEmptyObject(evaluatorUserInfo)) return;

                const evaluatorDisplayName = Utils.getUserNameWithActiveStatus(
                    evaluatorUserInfo,
                    true
                );
                if (Utils.isEmptyString(evaluatorDisplayName)) return;

                setEvaluatorUserNameMap(prev => ({
                    ...prev,
                    [evaluatorUserId]: evaluatorDisplayName
                }));
            } catch (error) {
                Logger.error('loadEvaluatorDisplayName error: ', error);
            }
        };

        loadEvaluatorDisplayName();
        return () => { cancelled = true; };
    }, [evaluatorUserId]);

    useEffect(() => {
        const panelHelpdeskTicketList = panelList.filter(panel =>
            [
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            ].includes(panel.type)
        );
        let newPanelList = _.cloneDeep(panelList);
        panelHelpdeskTicketList?.forEach(panelHelpdeskTicket => {
            let tabDeletedHelpdeskTicket = panelHelpdeskTicket.tabList?.map(tab =>
                tab.id === detailTicket?.id
                    ? {
                          ...tab,
                          isTicketDeleted: !Utils.isEmptyString(detailTicket.deletedAt)
                              ? true
                              : false
                      }
                    : tab
            );
            const newPanelHelpdeskTicket = {
                ...panelHelpdeskTicket,
                tabList: tabDeletedHelpdeskTicket
            };
            newPanelList = newPanelList.map(panel =>
                panel.type === panelHelpdeskTicket.type ? (panel = newPanelHelpdeskTicket) : panel
            );
        });

        setPanelList(newPanelList);
    }, [isSoftDelete])

    useEffect(() => {
        if (
            props.triggerReload ||
            triggerReloadTicket ||
            triggerReLoadHelpdeskTicketDetail === props.ticketId
        ) {
            getTicketDetail(props.ticketId, false);
            setTriggerReLoadHelpdeskTicketDetail('');
        }
    }, [
        props.triggerReload,
        triggerReLoadHelpdeskTicketDetail,
        props.ticketId,
        triggerReloadTicket
    ]);

    const viewTicketChildAndParent = async (ticketId, ticketOutline, isTicketChild) => {
        if (!ticketId) return;
        let type;
        let typeChatPanel;

        if (isHelpDesk) {
            if (isTicketChild) {
                type = Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
                typeChatPanel = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
            } else {
                type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
                // comment for now
                // typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
            }
        } else {
            if (!isTicketChild) {
                type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
                typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
            }
        }
        if (viewFromProjectOfEscalateTicket) {
            type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
        }
        if (!type) return;
        if (Utils.isEmptyString(ticketOutline)) {
            ticketOutline = '[概要 (現在未記入)]';
        }

        // open chat panel
        if (typeChatPanel) {
            addNewPanel({
                //update
                type: typeChatPanel,
                tabId: ticketId,
                ticketId: ticketId,
                props,
                ticketOutline: ticketOutline,
                isShowAllChatPost: false
            });
        }


        addNewPanel({
            //update
            type: type,
            tabId: ticketId,
            props,
            ticketId: ticketId,
            ticketOutline: ticketOutline
        });
    };

    const getTicketDetail = async (ticketId, isTicketChild = false, isFromEditTicket = false) => {
        setIsLoading(true);
        //get ticket detail
        let ticketDetailResult = await getTicketDetailAPI(
            props?.API,
            ticketId,
            selectedProject.id,
            currentUserDetail.id,
            isTicketChild
        );

        const TICKET_TYPES_GET_PROJECT_ORIGIN = [
            Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK,
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER,
            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
        ]
        let corporationDetailForGenShareLink = ticketDetailResult?.detailTicket?.affiliationOrganization
        if (TICKET_TYPES_GET_PROJECT_ORIGIN.includes(ticketDetailResult?.detailTicket?.ticketType)) {
            corporationDetailForGenShareLink = selectedProject?.affiliationOrganization
            if (selectedProject?.id !== ticketDetailResult?.detailTicket?.projectOrigin) {
                const projectOriginDetail = await getProjectById(props?.API, ticketDetailResult?.detailTicket?.projectOrigin)
                corporationDetailForGenShareLink = projectOriginDetail?.affiliationOrganization
            }
        }
        
        let corporationAffiliation = corporationDetail;
        if (corporationDetail.id !== corporationDetailForGenShareLink) {
            corporationAffiliation = await getCorporationById(props.API, corporationDetailForGenShareLink);
        }

        if (!ticketDetailResult || ticketDetailResult?.errors?.length > 0 || isMounted === false) return;

        if (ticketDetailResult?.isApprovedExternalDeskRequest) {
            setIsApprovedExternalDeskRequest(true);
        }

        if (ticketDetailResult?.isApprovedExternalCustomerRequest) {
            setIsApprovedExternalCustomerRequest(true);
        }
        setFormDetail(Utils.convertJSONDataToObject(ticketDetailResult.formDetail));
        let formDetailObject = Utils.convertJSONDataToObject(ticketDetailResult.formDetail);
        let fieldOrderInForm = {};

        if (!Utils.isEmptyObject(formDetailObject.structure)) {
            for (const [structureKey, structureValue] of Object.entries(formDetailObject.structure)) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
            setSettingTitleLineNumber(formDetailObject?.structure?.titleLineNumber);
        }

        let ticket = ticketDetailResult.detailTicket;
        ticket.dataShareLink = Utils.convertJSONDataToObject(ticketDetailResult?.dataShareLink);
        ticket.attachFiles = Utils.convertJSONDataToObject(ticketDetailResult?.attachFiles);
        ticket.usingFormName = ticketDetailResult.usingFormName;


        if (
            currentProjectId !== ticket.projectOrigin &&
            currentProjectId !== ticket.affiliationProject &&
            !ticket.projectTarget.includes(currentProjectId) &&
            ![
                Constant.TICKET_TYPE.TASK,
                Constant.TICKET_TYPE.BROADCAST_PARENT,
                Constant.TICKET_TYPE.BROADCAST_CHILD,
            ].includes(ticket.ticketType)
        ) {
            setViewFromProjectOfEscalateTicket(true);
        }
        let formDetailId = Utils.convertJSONDataToObject(ticketDetailResult?.formDetail)?.id;
        const createAt = new Date(ticket.createdAt);
        if (ticketDetailResult?.selectedProjectIsProjectOrigin) {
            const projectOrigin = selectedProject;
            let projectOriginName = "";

            if (projectOrigin.type === Constant.PROJECT_TYPE.BASE) {
                projectOriginName = Constant.PROJECT_BASE_DISPLAY_NAME;
            } else {
                projectOriginName = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    projectOrigin.name
                );
            }

            ticket.projectOriginName = projectOriginName;
        }
        if (ticketDetailResult?.currentUserIsCreator) {
            let createrUserName = Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                currentUserDetail
            );
            if (ticket.ticketType === Constant.TICKET_TYPE.TELEPHONE) {
                createrUserName = Utils.getUserNameWithActiveStatus(currentUserDetail);
            }
            if (!Utils.isEmptyString(createrUserName)) {
                createrUserName = createrUserName.replace('\n', ' ');
            }
            ticket.createrUserName = createrUserName;
        }
        if (lastUserAction && lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
            let contentTypes = LogKibanaConstant.CONTENT_TYPES_TICKET.QA;
            let dataLog = {
                corporationDetail: corporationDetail,
                projectDetail: projectDetails,
                rootCorporationDetail: {
                    id: ticket.affiliationOrganization
                },
                rootProjectDetail: {
                    id: ticket.affiliationProject,
                    name: ticket.projectTargetName
                },
                userDetail: currentUserDetail,
                contentTypes: contentTypes,
                ticketDetail: ticket,
                metaData: {
                    formDetailId,
                    selectedProject,
                    ticketType: ticket.ticketType,
                }
            };
            let operationScreen = LogKibanaConstant.OPERATION_SCREEN.SOLUTION_DESK;
            let logKibanaData = createKibanaDataContentOperation(
                lastUserAction,
                dataLog,
                operationScreen
            );
            if (logKibanaData) {
                if (ticket.ticketType === Constant.TICKET_TYPE.TASK) {
                    logKibanaData = formatViewTicketTaskLogKibana(logKibanaData)
                }
                let param = {
                    logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW,
                    logKibanaData: logKibanaData
                };
                createKibanaLogAPI(props?.API, param);
            }
            setLastUserAction(null);
        }

        const buildWorkflowStatusData = (rawStatus, rawStatusDetail) => {
            const parsedStatus = Utils.convertJSONDataToObject(rawStatus);
            const statusObject =
                parsedStatus && typeof parsedStatus === 'object' && !Array.isArray(parsedStatus)
                    ? parsedStatus
                    : {};
            if (Utils.isEmptyObject(statusObject)) {
                return {};
            }

            const parsedStatusDetail = Utils.convertJSONDataToObject(rawStatusDetail);
            const statusDetailObject =
                parsedStatusDetail &&
                typeof parsedStatusDetail === 'object' &&
                !Array.isArray(parsedStatusDetail)
                    ? parsedStatusDetail
                    : {};

            const workflowStatusData = {
                status: statusObject,
                currentItemData: {
                    id: statusObject.status,
                    name: Utils.getTextByLanguage(
                        Constant.LANGUAGE_TYPE.JP,
                        statusDetailObject?.name
                    ),
                    no: statusDetailObject?.structure?.no || statusObject?.value,
                    color: statusDetailObject?.structure?.helpdesk?.color,
                    background: statusDetailObject?.structure?.helpdesk?.background
                }
            };

            if (
                !Utils.isEmptyObject(statusDetailObject) &&
                ticket.affiliationProject !== selectedProject.id
            ) {
                let customerLabel = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    statusDetailObject.viewForCustomer
                );
                workflowStatusData.currentItemData.color =
                    statusDetailObject?.structure?.customer?.color;
                workflowStatusData.currentItemData.background =
                    statusDetailObject?.structure?.customer?.background;
                if (!Utils.isEmptyString(customerLabel)) {
                    workflowStatusData.currentItemData.name = customerLabel;
                }
            }

            return workflowStatusData;
        };

        const ticketWorkflowStatus = buildWorkflowStatusData(ticket.status, ticket.statusDetail);
        const telephoneWorkflowStatus = buildWorkflowStatusData(
            ticket.telephoneStatus,
            ticket.telephoneStatusDetail
        );

        setStatusOfTicket({ ...ticketWorkflowStatus });
        setTelephoneStatusOfTicket({ ...telephoneWorkflowStatus });

        // Update status of currentPanelInitData
        if (!Utils.isEmptyObject(currentPanelInitData)) {
            let newCurrentPanelInitData = cloneDeep(currentPanelInitData);
            newCurrentPanelInitData[Constant.PANEL_STATUS_KEY.TICKET] = ticketWorkflowStatus.currentItemData || {};
            newCurrentPanelInitData[Constant.PANEL_STATUS_KEY.TELEPHONE_WORKFLOW] =
                telephoneWorkflowStatus.currentItemData || {};
            if (isFromEditTicket) {
                newCurrentPanelInitData.formData = {};
            }
            setCurrentPanelInitData(newCurrentPanelInitData);
        }
        // Check if isAnonymousQARejectTicket => close panel
        if (ticket.public === Constant.TICKET_PUBLIC.DRAFT) {
            closePanelTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId: ticket.id
            });
            return;
        }
        
        // set is isAnonymousQAWaitingTicket
        setIsAnonymousQAWaitingTicket(Utils.isAnonymousQAWaitingTicket(ticket));

        if (ticketDetailResult?.fieldListData) {
            let listField = Utils.convertJSONDataToObject(ticketDetailResult?.fieldListData);
            
            //filter field is active
            if (formDetailObject.definition !== Constant.FORM_DEFINITION.SYSTEM) {
                listField = listField?.filter(field => {
                    if (
                        field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                        field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                    ) {
                        return true;
                    }
                    const usingProjectOfField = Utils.convertJSONDataToObject(field?.usingProjects);
                    if (Utils.isEmptyArray(usingProjectOfField)) {
                        return false;
                    } else {
                        return field?.usingProjects?.includes(formDetailObject.affiliationProject);
                    }
                });
            }

            if (
                selectedProject.id !== ticket.affiliationProject &&
                (currentUserDetail?.id === ticket.customer ||
                    selectedProject.id === ticket.customer)
            ) {
              
                listField = listField.filter(x => Number(x.publicForCustomer) !== Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW);
                const listFieldPublicForCustomer = listField.filter(
                    field => field.publicForCustomer == Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER
                );
                if (Utils.isEmptyArray(listFieldPublicForCustomer)) {
                    setHasEditPermission(false);
                } else {
                        listField = Array.from(listField, field => {
                            if (Number(field.publicForCustomer) === Constant.SETTING_FORM_DEFAULT.READ_ONLY) {
                                field.structure.required = false;
                            }
                            return field;
                        });
                        setHasEditPermission(true);
                    }
            }

            if (selectedProject.id === ticket.affiliationProject) {
                listField = Array.from(listField, x => {
                    x.publicForCustomer = Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
                    return x;
                });

                setHasEditPermission(true);
            }
            if(ticket.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD){
                listField = Array.from(listField, x => {
                    x.publicForCustomer = 2;
                    return x;
                });

                setHasEditPermission(false);
            }
            
            if (ticket.ticketType === Constant.TICKET_TYPE.TELEPHONE) {
                listField = Array.from(listField, field => {
                    // Check if field is telephone system field
                    const notEditFields = Object.values(
                        TelephoneConstant.TELEPHONE.NOT_EDIT_FIELD
                    );
                    if (notEditFields.includes(field.sysField)) {
                        const readOnly = Constant.SETTING_FORM_DEFAULT.READ_ONLY;
                        field.publicForCustomer = readOnly;
                        field.structure.publicForCustomer = readOnly;
                    }
                    return field;
                });
            }
            
            if (
                (ticket.public === Constant.TICKET_PUBLIC.PUBLIC &&
                    (ticket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER ||
                        ticket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT ||
                        ticket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT ||
                        ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK ||
                        ticket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER)) ||
                ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED ||
                (Utils.isAnonymousQAWaitingTicket(ticket) &&
                    (ticket.customer === Constant.ANONYMOUS_USER_ID || isHelpDesk)) ||
                Utils.isAnonymousQARejectTicket(ticket) ||
                Utils.isAnonymousQAWaitingOrEndLiveChatTicket(ticket) ||
                (!Utils.isEmptyObject(ticketDetailResult?.corporationOriginData) &&
                    ticketDetailResult.corporationOriginData.active ===
                        Constant.CORPORATION_ACTIVE.DELETED) ||
                Utils.isDisabledTicketExternalWhenDeskServiceOff(ticketDetailResult?.detailTicket, corporationDetail) ||
                Utils.isAnonymousQAEndLiveChatTicket(ticket)
            ) {
                listField = Array.from(listField, x => {
                    x.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY;
                    return x;
                });
            }

            // Fix for task ticket
            if (ticket.ticketType === Constant.TICKET_TYPE.TASK && ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE) {
                listField = Array.from(listField, x => {
                    x.publicForCustomer = Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
                    return x;
                });
                setHasEditPermission(true);
            }

            setIsDisableDeskService(
                !Utils.isDisabledTicketExternalWhenDeskServiceOff(
                    ticketDetailResult?.detailTicket,
                    corporationDetail
                )
            );

            // Check corporationOrigin deleted
            if (
                !Utils.isEmptyObject(ticketDetailResult?.corporationOriginData) &&
                ticketDetailResult.corporationOriginData.active ===
                    Constant.CORPORATION_ACTIVE.DELETED
            ) {
                setIsDisableEdit(true);
            }

            if(!Utils.isEmptyObject(ticketDetailResult?.corporationOriginData)) {
                ticket.corporationOriginName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, ticketDetailResult?.corporationOriginData?.name);
            }

            let fieldListDataForEditTicket = [];
            listField.forEach(fieldData => {
                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue:
                        fieldData.type === Constant.FORM_TYPE.FIELD_TAG
                            ? fieldData.defaultValue
                            : fieldData.value
                };
                if (
                    Utils.isAnonymousQAWaitingTicket(ticket) &&
                    ticket.affiliationProject === selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                } else if (
                    [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(ticket.ticketType) &&
                    fieldDataTmp.sysField === Constant.SYS_FIELD.ATTACHMENTS &&
                    ticket.affiliationProject !== selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                }
                else {
                    fieldDataTmp.structure.publicForCustomer = Number(fieldData.publicForCustomer)
                }

                fieldListDataForEditTicket.push(fieldDataTmp);
            });


            // Check if current panel is QA panel (問い合わせ詳細)
            const isCurrentPanelQA = [
                Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST,
                Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            ].includes(props?.panelType);
            const hasQAPanelOnly = [Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(selectedProject?.type);

            // Check if form is TELEPHONE_FORMAT
            const isTelephoneFormat =
                formDetailObject?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT;

            fieldListDataForEditTicket = fieldListDataForEditTicket.filter(field => {
                // Filter out always-hidden fields
                if (TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) {
                    return false;
                }

                // Filter out telephone-specific fields when viewing TELEPHONE_FORMAT ticket in QA panel
                if (
                    (isCurrentPanelQA || hasQAPanelOnly) &&
                    isTelephoneFormat &&
                    TelephoneConstant.TELEPHONE.HIDDEN_FIELDS_IN_QA_DETAIL?.includes(field.sysField)
                ) {
                    return false;
                }

                return true;
            }).sort((a, b) => {
                // attachment always at bottom
                if (a.sysField === 'attachments') return 1
                if (b.sysField === 'attachments') return -1 
                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }
                return a.order[currentProjectId] - b.order[currentProjectId]
            })

            if(isTelephoneFormat) {
                let telephoneFromField = fieldListDataForEditTicket.find(field => field.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FROM);
                if(!Utils.isEmptyString(telephoneFromField?.value)) {
                    setTelephoneFromName(telephoneFromField?.value);
                }
            }

           
            setFieldListDefaultData(fieldListDataForEditTicket);
            setListFieldData([...listField]);
            const mappingDataIdToIdObj = Utils.convertJSONDataToObject(
                ticketDetailResult?.mappingDataIdToIdObj
            );
            
            setMapDataIdToId({ ...mappingDataIdToIdObj });
        }

        const updatedAt = new Date(ticket.updatedAt);
        ticket.createTime = moment(createAt).format('YYYY/MM/DD HH:mm');
        ticket.updatedTime = moment(updatedAt).format('YYYY/MM/DD HH:mm');

        const timeHasPassed = Utils.getTimeToDateNow(createAt);
        ticket.timeHasPassed = timeHasPassed;

        //HERE ???
        let ticketOutline = ticket.outline ? Utils.convertJSONDataToObject(ticket.outline)?.jp : '';
        ticket.ticketOutline = ticketOutline;
        if (ticket?.listTicketChild) {
            if (Utils.isEmptyArray(Utils.convertJSONDataToObject(ticket?.listTicketChild))) {
                setListTicketChild([...Utils.convertJSONDataToObject(ticket?.listTicketChild)]);
            }
        }

        //if ticket is ticket child of current ticket, setTicketParent = current ticket
        if (isTicketChild){
            ticket.parentTicket = JSON.stringify({
                id: detailTicket.id,
                outline: Utils.convertJSONDataToObject(detailTicket.outline).jp
            }); 
            if (Utils.convertJSONDataToObject(ticket.customersCustomer)?.ticketQA) {
                setIsDisplayTicketParent(false);
            } else {
                if (
                    detailTicket.projectOrigin === selectedProject.id ||
                    detailTicket.affiliationProject === selectedProject.id
                ) {
                    setIsDisplayTicketParent(false);
                } else {
                    setIsDisplayTicketParent(false);
                }
            }
        } else {
            const parent = ticket?.parentTicket
                ? Utils.convertJSONDataToObject(ticket.parentTicket)
                : {};

            setTicketParent(parent);

            const customer = Utils.convertJSONDataToObject(ticket?.customersCustomer);
            setIsDisplayTicketParent(!!customer?.ticketQA);
        }

        if (viewFromProjectOfEscalateTicket) {
            setIsDisplayTicketParent(false);
        }

        if (
            (Utils.isAnonymousQAWaitingTicket(ticket) &&
                ticket.affiliationProject === selectedProject.id) ||
            Utils.isAnonymousQAEndLiveChatTicket(ticket) ||
            Utils.isDisabledTicketExternalWhenDeskServiceOff(ticket, corporationDetail)
        ) {
            setHasEditPermission(false);
        }
        const title = getTitle(ticket.settingTitle);
        if (Utils.isEmptyArray(ticket.settingTitle)) {
            setSettingTitle([]);
        } else {
            setSettingTitle([...ticket.settingTitle]);
        }
        ticket.outline = title

        // Update assignee avatar
        if (ticket?.personInChargeInfo?.avatar) {
            let avatarData = await Storage.get(ticket?.personInChargeInfo?.avatar);
            ticket.personInChargeInfo = {
                ...ticket.personInChargeInfo,
                avatar: avatarData
            }
        }

        let bookmarkData = Utils.convertJSONDataToObject(ticket?.bookmarkInfo)
        ticket.privateBookmarkData = bookmarkData.privateBookmarkData
        ticket.shareBookmarkData = bookmarkData.shareBookmarkData
        ticket.totalPrivateBookmark = bookmarkData.totalPrivateBookmark
        ticket.isBookmarkedDefaultBookmark = bookmarkData.isBookmarkedDefaultBookmark
        ticket.bookmarkListText = bookmarkData.bookmarkListText
        delete ticket.bookmarkInfo

        setDetailTicket(ticket);
        setCorporationAffiliationTicket(corporationAffiliation)
        setIsSoftDelete(!Utils.isEmptyString(ticket.deletedAt))
        setIsLoading(false);

        // open chat panel
        let idBtnChat = `open-chat-${props.panelId}-${props.tabId}`;
        let buttonChat = document.getElementById(idBtnChat);
        if(buttonChat && props.isOpenChat) {
            buttonChat.click();
        }

        return ticket;
    };

    const handleAddPanel = () => {
        let ticketOutline = ''
        if (Utils.isEmptyArray(detailTicket.settingTitle)) {
            ticketOutline = argsAll.detailTicket.outline
        } else {
            ticketOutline = getTitle(detailTicket.settingTitle)
        }

        let openRelatePanelType = false;
        if (props.isOpenChat && props) {
            openRelatePanelType = isHelpDesk ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        }
        addNewPanel({
            //update
            type: isHelpDesk
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            tabId: props.ticketId,
            ticketId: props.ticketId,
            props,
            ticketOutline: ticketOutline,
            isTicketDeleted: !Utils.isEmptyString(detailTicket?.deletedAt) ? true : false,
            isShowAllChatPost: false,
            openRelatePanelType: openRelatePanelType
        });
        setAnchorShowMoreActionsPopover(null);
    };

    const onOpenKnowledge = () => {
        const existedKnowledgeHelpdeskTicketListPanel = panelList.find(
            panel => (Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST, Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type)
        );
        
        if (!Utils.isEmptyObject(existedKnowledgeHelpdeskTicketListPanel)) {
            closePanelTab({
                event: null,
                panelType: existedKnowledgeHelpdeskTicketListPanel.type,
                panelId: existedKnowledgeHelpdeskTicketListPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            customerId: '',
            projectSelectedId: userPermissionView.projectSelectedId,
            corporationSelectedId: userPermissionView.corporationSelectedId,
            props : {
                ...props,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            }
        }
        if (
            userPermissionView.projectSelectedId !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer || userPermissionView.projectSelectedId === detailTicket.customer)
        ) {
            setIsShowVisibilityKnowledgeAtom(false);
            
            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
            addNewPanelParams.customerId = detailTicket.customer
            addNewPanelParams.projectSelectedId = detailTicket.affiliationProject
            addNewPanelParams.corporationSelectedId = detailTicket.affiliationOrganization
        }
        addNewPanel(addNewPanelParams)
        setAnchorShowMoreActionsPopover(null);                                                           
    };

    const filterNonEditableFieldsForTelephone = (editedFieldValue, fieldList, fieldIdMapping, ticket) => {
        // Check if ticket is TELEPHONE type
        if (ticket?.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
            return editedFieldValue;
        }

        // Get list of non-editable telephone fields
        const nonEditableFields = Object.values(TelephoneConstant.TELEPHONE.NOT_EDIT_FIELD);
        
        // Clone the editedFieldValue to avoid mutation
        const filteredValue = { ...editedFieldValue };

        // Filter out non-editable fields from main field values
        for (const ticketFieldId in filteredValue) {
            if (ticketFieldId === 'newFieldValue') {
                continue; // Handle newFieldValue separately
            }

            // Find the fieldId from fieldIdMapping
            const fieldId = Object.keys(fieldIdMapping).find(id => fieldIdMapping[id] === ticketFieldId);
            if (!fieldId) {
                continue;
            }

            // Find field metadata
            const fieldMetadata = fieldList.find(field => field.id === fieldId);
            if (!fieldMetadata) {
                continue;
            }

            // If sysField is in non-editable list, remove it
            if (fieldMetadata.sysField && nonEditableFields.includes(fieldMetadata.sysField)) {
                delete filteredValue[ticketFieldId];
            }
        }

        // Filter newFieldValue array
        if (filteredValue.newFieldValue && Array.isArray(filteredValue.newFieldValue)) {
            filteredValue.newFieldValue = filteredValue.newFieldValue.filter(fieldObj => {
                const fieldKey = Object.keys(fieldObj)[0];
                const fieldMetadata = fieldList.find(field => field.id === fieldKey);
                
                if (!fieldMetadata) {
                    return true; // Keep if metadata not found
                }

                // Keep field only if it's NOT in non-editable list
                return !(fieldMetadata.sysField && nonEditableFields.includes(fieldMetadata.sysField));
            });
        }

        return filteredValue;
    };

    const handleEditTicketSubmit = async (formData, isEditDraft) => {
        if (isDisableBtnSaveTicket()) {
            argsAll?.setIsLoading(false);
            return;
        }

        let isEditDraftStatus = isEditDraft ? isEditDraft : false;
        let fields = Utils.getEditTicketData(formData, fieldListDefaultData);
        // validate exceed max size
        if (validateExceedSizeOfFieldTicket(fieldListDefaultData, setFieldListDefaultData, fields, setErrorMessageHeader)) {
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData)
            currentPanelInitDataClone.fileUpdatedList = [...fileUpdatedList]
            setCurrentPanelInitData({...currentPanelInitDataClone})
            argsAll.setIsLoading(false);
            return;
        }

        let tagField = fields.tagField;
        if (!Utils.isEmptyObject(tagField)) {
            for (const fieldId in tagField) {
                let listNewItem = [];
                if (tagField[fieldId]) {
                    for (const item of tagField[fieldId]) {
                        if (item && item.isNewItem) {
                            const parentField = fieldListDefaultData.find(
                                field => field.fieldId === fieldId
                            );
                            const itemData = {
                                usage: Constant.FORM_USAGE.TAG,
                                name: JSON.stringify({
                                    jp: {
                                        A: 'F',
                                        text: item.title
                                    }
                                }),
                                affiliationOrganization: parentField.affiliationOrganization,
                                affiliationProject: parentField.affiliationProject,
                                affiliationField: parentField.id,
                                creator: currentUserDetail.id,
                                updator: currentUserDetail.id,
                                type: '',
                                structure: JSON.stringify({
                                    isShowItemInTicket: true,
                                    no: item.no
                                }),
                                viewForCustomer: JSON.stringify({}),
                                definition: Constant.FORM_DEFINITION.USER,
                                explanation: JSON.stringify({}),
                                usingProjects: parentField.usingProjects,
                                hitNumber: 0,
                                hasValue: true
                            };
                            listNewItem.push(itemData);
                        }
                    }
                    const listNewId = await bulkCreateTagItem(props?.API, listNewItem);
                    fields[fieldId].push(...listNewId);
                    //fields[fieldId] = JSON.stringify(fields[fieldId])
                }
            }
        }
        delete fields.tagField;
       
        let updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        };

        let editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);
        
        // Filter out non-editable fields for telephone tickets
        editedFieldValue = filterNonEditableFieldsForTelephone(editedFieldValue, fieldListDefaultData, mapDataIdToId, detailTicket);
        
        editedFieldValue = await Utils.putFieldDataToS3BeforeEditTicket(editedFieldValue, mapDataIdToId, fieldListDefaultData, detailTicket);
        

        setIsLoading(true);
        const fieldEdited = [
            ...new Set([...(currentTabData?.listFieldEdited || []), ...listFieldEdited])
        ];
        const args = { ...argsAll, listFieldEdited: fieldEdited };
        const updateResult = await submitUpdateTicket(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            isEditDraftStatus,
            args,
        );
     
        if(updateResult?.isConfirm){
            return
        }
       
        let newTicketDetail = await getTicketDetail(detailTicket.id, false);
        let newOutline = newTicketDetail.outline
        if(!Utils.isEmptyArray(newTicketDetail?.settingTitle)){
            newOutline = getTitle(newTicketDetail?.settingTitle)
        }
       
        if (Utils.isAnonymousQATicketFromLiveChat(newTicketDetail) && newStatusData.no === Constant.STATUS_NO.DONE ) {
            reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
                id: newTicketDetail.id
            });
        }

        // reset submitted listFieldEdited
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', []);
        
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });

        updateTabNameAfterEditTicket(argsAll, newOutline, props.panelId, detailTicket.id);
        setIsEdited(false);
        setListFieldEdited([]);

        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    };

    const bookmarkTargetType = useMemo(() => {
        return Utils.getBookmarkTargetTypeByTicketType(detailTicket?.ticketType);
    }, [detailTicket]);

    const submitSoftDelete = async () => {
        const deletedAt = isSoftDelete
            ? null
            : new Date().toISOString();
        setIsLoading(true);
        if (isSoftDelete) {
            setIsShowDialogRestoreTicket(false);
        }
        let result = await submitSoftDeleteTicket(props?.API, detailTicket, deletedAt, currentUserDetail, argsAll);
        if(result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }
        let newTicketDetail = await getTicketDetail(detailTicket.id, false, true);

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        reloadPanelAfterSoftDeleteTicketByPanelType({
            panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            id: detailTicket.id
        });
        updateTabNameAfterEditTicket(argsAll, newTicketDetail?.outline, props.panelId, detailTicket.id);
        // reload escalate ticket
        detailTicket.inhouseCollaboratorTicketId?.forEach(collabTicketId => {
            reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                id: collabTicketId
            });
            reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
                id: collabTicketId
            })
        });

        // reload parent ticket
        if (detailTicket.parent) {
            reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                id: detailTicket.parent
            });
        }

        if (detailTicket.children?.length > 0) {
            const softDeleteTicketChildPromise = [];
            detailTicket.children.forEach(childId => {
                const detailTicketChild = {
                    id: childId,
                    ticketType: Constant.TICKET_TYPE.BROADCAST_CHILD
                };
                softDeleteTicketChildPromise.push(
                    submitSoftDeleteTicket(
                        props?.API,
                        detailTicketChild,
                        deletedAt,
                        currentUserDetail,
                        argsAll
                    )
                );
            });
            await Promise.all(softDeleteTicketChildPromise);
        }

        let msgNotiDeleteSuccess = I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY');
        if (isSoftDelete) {
            setIsSoftDelete(false);
            reloadPage();
        } else {
            msgNotiDeleteSuccess = I18n.get('MSG-CM-DELETE-CONTENT-SUCCESSFULLY');
            setIsSoftDelete(true);
        }

        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        setAnchorShowMoreActionsPopover(null);

        enqueueSnackbar(msgNotiDeleteSuccess, {
            variant: 'success',
            autoHideDuration: 3000
        });
    };

    const restoreAnonymousTicket = async () => {
        const anonymousQaStatus = Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE;
        setIsShowDialogRestoreTicket(false);
        setIsLoading(true);
        let result = await submitRestoreAnonymousTicket(props?.API, detailTicket, anonymousQaStatus, currentUserDetail, argsAll);
        if(result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }
        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        enqueueSnackbar(I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        setIsRejectTicketAnonymous(false);
        reloadPage();
    }

    const handleSoftDeleteTicket = () => {
        setAnchorShowMoreActionsPopover(null);
        setIsOpenPopupSoftDelete(true);
    }

    const handleDeleteTicket = async () => {
        setIsLoading(true);
        let ticketId = detailTicket.id;
        let currentStatusTicket = await checkDetailTicket(props?.API, ticketId);
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
            setIsLoading(false);
            setIsOpenPopupTicketError(true);
            return;
        }
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.INUSED) {
            setIsLoading(false);
            setIsOpenPopupTicketMsg(true);
            return;
        }

        // handle HARD_DELETE
        let removeOldTicket = await deleteAllTicketData(props?.API, {
            ticketId: ticketId
        });
        if (!removeOldTicket) {
            setIsLoading(false);
            enqueueSnackbar(I18n.get('COMMSG002'), {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }

        if(isTicketCountNumber(detailTicket.ticketType) && detailTicket.affiliationOrganization === argsAll.corporationDetail.id) {
            let corpDetailResult = await getCorporationDetailByCorporationDomain(props?.API, corporationDetail.organizationDomain);
            setCorporationDetail(corpDetailResult);
        }

        const chatThreadPanelType =
            props.ticketListType === 'helpdesk'
            || props.panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
        
        const chatPanel = panelList.find(panel => panel.type === chatThreadPanelType);

        if (!Utils.isEmptyObject(chatPanel)) {
            closePanelTab({
                event: null,
                isCloseMulti: true,
                closeList: [
                    {
                        panelType: chatThreadPanelType,
                        panelId: chatPanel.id,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    },
                    {
                        panelType: getPanelType(),
                        panelId: props.panelId,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    }
                ]
            });
        } else {
            closePanelTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId:
                    detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                        ? props.ticketId
                        : props.tabId
            });
        }

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        let flashMsg = I18n.get('MSG-CM-COMPLETE-DELETE-CONTENT-SUCCESSFULLY');
        enqueueSnackbar(flashMsg, {
            variant: 'success',
            autoHideDuration: 3000
        });

        hideLoadingMouse();
    }

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };

    /**
     * Handle callback button click
     * Trigger callback action cho telephone ticket
     */
    const handleCallbackButtonClick = async (event) => {
        if (event) {
            event.stopPropagation();
        }

        try {
            let callTarget = '';
            const metaData = Utils.convertJSONDataToObject(detailTicket?.metaData);
            const callDirection = metaData?.callDirection;
            const callType = metaData?.callType || '';
            const isVoiceCallTicket = callType === TelephoneConstant.CALL_TYPE.VOICE_CALL;
            if (isVoiceCallTicket) {
                callTarget = resolveVoiceCallTarget(metaData, detailTicket, selectedProject.id);
            } else {
                switch (callDirection) {
                    case TelephoneConstant.CALL_DIRECTION.INBOUND:
                        callTarget = metaData?.from;
                        break;
                    case TelephoneConstant.CALL_DIRECTION.OUTBOUND:
                        callTarget = metaData?.to;
                    break;
                    default:
                        break;
                }
            }
            console.log('handleCallbackButtonClick', callTarget)
          
            // Validate call target
            if (!callTarget || Utils.isEmptyString(callTarget)) {
                console.log('call target is empty', { callTarget, metaData, ticketId: detailTicket.id })
                return;
            }

            if (!isVoiceCallTicket) {
                // Validate telephone agent permission before making phone call retry.
                const validationResult = await validateTelephonePermission(
                    corporationDetail.id,
                    selectedProject.id
                );
                if (!validationResult.isValid) {
                    console.log('❌ handleCallBackCustomer: Telephone agent permission denied');
                    setIsOpenModalReloadPage(true);
                    return;
                }
            }

            // Check if ticket still exists (not deleted/archived by another user)
            const ticketStatus = await checkDetailTicket(props?.API, detailTicket.id);
            if (ticketStatus.status !== Constant.TICKET_DELETED_STATUS.INUSED) {
                console.log(' handleCallBackCustomer: Ticket deleted or archived', ticketStatus);
                if (ticketStatus.status === Constant.TICKET_DELETED_STATUS.ARCHIVED) {
                    setContentModalReloadPage(I18n.get('MSG-CM-CHANGED-DATA'));
                } else {
                    setContentModalReloadPage(I18n.get('MSG-CM-DELETED-TICKET'));
                }
                setIsOpenModalReloadPage(true);
                return;
            }

            const callTargetName = isVoiceCallTicket
                ? await resolveVoiceCallTargetName(callTarget, outline)
                : '';
            const calleeProjectId = (
                isVoiceCallTicket &&
                Utils.getPrefixOfId(callTarget) === Constant.ID_PREFIX.PROJECT
            ) ? callTarget : '';
            const phoneData = {
                phone: callTarget,
                name: callTargetName,
                projectId: selectedProject.id,
                callerProjectId: selectedProject.id,
                calleeProjectId,
                sourcePanel: 'TICKET_DETAIL',
                ticketId: detailTicket.id,
                callType: isVoiceCallTicket
                    ? TelephoneConstant.CALL_TYPE.VOICE_CALL
                    : TelephoneConstant.CALL_TYPE.PHONE_CALL
            };

            // Call initiateCall function
            await initiateCall(phoneData);

            // Retry case: telephoneStatus is missed/cancelled → open panel with current ticketId
            const currentCallStatus = getTelephoneStatusFromTicket(detailTicket);
            const isRetry = [
                TelephoneConstant.TELEPHONE_CALL_STATUS.MISSING_CALL,
                TelephoneConstant.TELEPHONE_CALL_STATUS.CANCELLED_CALL
            ].includes(currentCallStatus);
            if (isRetry) {
                openTelephoneTicketPanel(
                    { ticketId: detailTicket.id },
                    selectedProject,
                    projectList,
                    addNewPanel
                );
            }
            // Follow-up case (END_CALL): subscription handler will open panel when new ticket is created

        } catch (error) {
            console.error('Error calling back customer:', error);
        }
    };

    const saveAndCancel = async e => {
        if (isDisableBtnSaveTicket()) {
            argsAll?.setIsLoading(false);
            return;
        }
        
        let formData = getValuesEditTicket();
        let fields = Utils.getEditTicketData(formData, fieldListDefaultData);

        // validate exceed max size
        if (validateExceedSizeOfFieldTicket(fieldListDefaultData, setFieldListDefaultData, fields, setErrorMessageHeader)) {
            argsAll.setIsLoading(false);
            return;
        }
        
        let tagField = fields.tagField;
        if (!Utils.isEmptyObject(tagField)) {
            for (const fieldId in tagField) {
                let listNewItem = [];
                if(tagField[fieldId]) {
                    for (const item of tagField[fieldId]) {
                        if (item && item.isNewItem) {
                            const parentField = fieldListDefaultData.find(
                                field => field.fieldId === fieldId
                            );
                            const itemData = {
                                usage: Constant.FORM_USAGE.TAG,
                                name: JSON.stringify({
                                    jp: {
                                        A: 'F',
                                        text: item.title
                                    }
                                }),
                                affiliationOrganization: parentField.affiliationOrganization,
                                affiliationProject: parentField.affiliationProject,
                                affiliationField: parentField.id,
                                creator: currentUserDetail.id,
                                updator: currentUserDetail.id,
                                type: '',
                                structure: JSON.stringify({
                                    isShowItemInTicket: true,
                                    no: item.no
                                }),
                                viewForCustomer: JSON.stringify({}),
                                definition: Constant.FORM_DEFINITION.USER,
                                explanation: JSON.stringify({}),
                                usingProjects: parentField.usingProjects,
                                hitNumber: 0,
                                hasValue: true
                            };
                            listNewItem.push(itemData);
                        }
                    }
                    const listNewId = await bulkCreateTagItem(props?.API, listNewItem);
                    fields[fieldId].push(...listNewId);
                    //fields[fieldId] = JSON.stringify(fields[fieldId])
                }
            }
        }
        delete fields.tagField;
        // let newOutline = JSON.stringify(formData?.outline ? { jp: formData.outline } : {});
        let updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        };

        let editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);
        // Filter out non-editable fields for telephone tickets
        editedFieldValue = filterNonEditableFieldsForTelephone(editedFieldValue, fieldListDefaultData, mapDataIdToId, detailTicket);
        
        editedFieldValue = await Utils.putFieldDataToS3BeforeEditTicket(editedFieldValue, mapDataIdToId, fieldListDefaultData, detailTicket);

        setIsLoading(true);
        const fieldEdited = [
            ...new Set([...(currentTabData?.listFieldEdited || []), ...listFieldEdited])
        ];
        const args = { ...argsAll, listFieldEdited: fieldEdited };
        const updateResult = await submitUpdateTicket(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            false,
            args
        );
       
        if(updateResult?.isConfirm){
            return
        }
       
        let newTicketDetail = await getTicketDetail(detailTicket.id);
        if (Utils.isAnonymousQATicketFromLiveChat(newTicketDetail) && newStatusData.no === Constant.STATUS_NO.DONE ) {
            reloadPanelAfterSoftDeleteTicketByPanelType({
                panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
                id: newTicketDetail.id
            });
        }
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        updateTabNameAfterEditTicket(argsAll, newTicketDetail.outline, props.panelId, detailTicket.id);
        // closePanelTab({
        //     event: e,
        //     panelType: getPanelType(),
        //     panelId: props.panelId,
        //     tabId: detailTicket.id
        // });
        setIsEdited(false);
        setListFieldEdited([])
        
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    };
    const handleCancelTicket = e => {
        if (isEdited) {
            setIsConfirmCancelEditTicket(true);
        } else {
            handleCloseTab(isEdited)
        }
    };

    const handleSaveDraftTicket = async () => {
        let formData = getValuesEditTicket();
        await handleEditTicketSubmit(formData, true);
    };

    const handleSentTicketFromDraft = async formData => {
        setIsLoading(true);

        let fields = Utils.getEditTicketData(formData, argsAll.fieldListDefaultData);
        // validate exceed max size
        if (validateExceedSizeOfFieldTicket(fieldListDefaultData, setFieldListDefaultData, fields, setErrorMessageHeader)) {
            argsAll.setIsLoading(false);
            return;
        }

        if (isEdited) {
            await handleEditTicketWhenSentFromDraft(formData, argsAll);
        }

        let paramsSentTicket = {
            ticketId: detailTicket.id,
            currentUserId: currentUserDetail.id,
            projectInuseId: currentProjectId,
            corporationId: corporationDetail.id
        };

        let sentTicket = await sentTicketFromDraft(props?.API, paramsSentTicket);
        if (!sentTicket || Utils.isEmptyObject(sentTicket)) {
            setIsLoading(false);
            return;
        }

        enqueueSnackbar(I18n.get('USER12MSG006'), {
            variant: 'success',
            autoHideDuration: 3000
        });

        let newTicketDetail = await getTicketDetail(detailTicket.id, false, true);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        updateTabNameAfterEditTicket(argsAll, newTicketDetail.outline, props.panelId, detailTicket.id);

        if(isTicketCountNumber(newTicketDetail.ticketType) && newTicketDetail.affiliationOrganization === argsAll.corporationDetail.id) {
            updateLimitNumOfTicket(argsAll);
        }

        setIsLoading(false);
        return;
    };

    const handleResetFormData = () => {
        setCurrentPanelInitData({});
        const newFieldListDefaultData = cloneDeep(fieldListDefaultData);
        setFieldListDefaultData(newFieldListDefaultData);

        if (!Utils.isEmptyArray(fieldListDefaultData)) {
            fieldListDefaultData.forEach(field => {
                if (!Utils.isEmptyObject(field)) {
                    setValueEditTicket(field.id, field.defaultValue);
                }
            });
        }
        
        setOutLine(detailTicket.outline);
        // Clear all err
        setErrorMessageHeader('');
        clearErrors();
        setIsEdited(false);
        setListFieldEdited([]);
        setFileUploadList([]);
    };

    const isDisplayButtonEditTicket = () => {
        if (Utils.isAnonymousLiveChatWaitingTicket(detailTicket)) {
            return false;
        }

        // Fix for ticket notice
        if (detailTicket.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD) {
            return false;
        }
        if (
            [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.TELEPHONE].includes(detailTicket.ticketType) && 
            detailTicket.affiliationProject !== selectedProject.id
        ) {
            return false;
        }

        return (
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER &&
            hasEditPermission
        );
    };
    const isDisplayButtonCluster = () => {
        if (isAnonymousQAWaitingTicket && isHelpDesk) return false;
        if(isSoftDelete || isRejectTicketAnonymous) return false;
        return (
            isDisplayButtonEditTicket() ||
            isDisplayButtonArchivedTicket() ||
            isDisplayButtonCancelTicket() ||
            isDisplayButtonSoftDeleteTicket()
        );
    };

    const isDisplayButtonArchivedTicket = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer ||
                selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        if(Utils.isDisabledTicketExternalWhenDeskServiceOff(
            detailTicket,
            corporationDetail
        )) {
            return false;
        }

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER
        );
    };

    const isDisplayButtonBackToArrival = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer ||
                selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER
        );
    }

    const isDisplayButtonCancelTicket = () => {
        if(Utils.isAnonymousLiveChatWaitingTicket(detailTicket)) {
            return false;
        }
        return (
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            (detailTicket.ticketType === Constant.TICKET_TYPE.QA ||
                detailTicket.ticketType === Constant.TICKET_TYPE.INTERNAL_QA ||
                detailTicket.ticketType === Constant.TICKET_TYPE.EXTERNAL_QA ||
                detailTicket.ticketType === Constant.TICKET_TYPE.ESCALATION ||
                detailTicket.ticketType === Constant.TICKET_TYPE.DELEGATE ||
                detailTicket.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT ||
                detailTicket.ticketType === Constant.TICKET_TYPE.TASK) &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER &&
            detailTicket.ticketType !== Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER &&
            hasEditPermission
        );
    };

    const isDisplayButtonSoftDeleteTicket = () => {
        if (
            [Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(detailTicket?.ticketType) &&
            selectedProject.id === detailTicket.projectOrigin &&
            !detailTicket.deletedAt
        ) {
            return true;
        }

        if(Utils.isAnonymousQATicketFromLiveChat(detailTicket)) {
            return false;
        }
        const isInvitationTicket =
            detailTicket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT ||
            detailTicket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT ||
            detailTicket.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER ||
            detailTicket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK ||
            detailTicket.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER;

        if (
            detailTicket.ticketType === Constant.TICKET_TYPE.ESCALATION &&
            selectedProject.id === detailTicket.projectOrigin
        ) {
            return false;
        }

        if (
            ((detailTicket.isExternalTicket && !isInvitationTicket) ||
                (isGeneralUser && !detailTicket.isExternalTicket && !isInvitationTicket) ||
                (isInvitationTicket &&
                    detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED)) &&
            ([
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
            ].includes(props.panelType) ||
                props.ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK || isHelpDesk) &&
            hasEditPermission
        ) {
            return true;
        }
        return false;
    };

    const reloadPage = () => {
        setTriggerReloadTicket(Date.now().toString());
    }

    const handleReloadComponent = () => {
        setIsOpenPopupTicketError(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        closePanelTab({
            event: null,
            panelType: getPanelType(),
            panelId: props.panelId,
            tabId: props.tabId
        });
        closePanelTab({
            event: null,
            panelType:
                props.ticketListType === 'helpdesk'
                    ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                    : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            panelId: props.panelId,
            tabId: props.tabId
        });
    }

    const isTicketQALiveChatSoftDelete = () => {
        return Utils.isAnonymousQATicketFromLiveChat(detailTicket) && detailTicket.deletedAt
    }

    const renderBtnCompletedDeleteAndRestoreTicket = () => {
        if (
            ((isSoftDelete || isRejectTicketAnonymous) && isGeneralUserWithGuest) &&
            !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail)
        ) {
            return (
                <>
                    {!isTicketQALiveChatSoftDelete() && (
                    <Button
                        className="btn-send btn-outline-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsShowDialogRestoreTicket(true)}
                    >
                        復元
                        </Button>
                    )}
                </>
            );
        }
    };

    const onClickCloseConfirmDialog = () => {
        setIsShowDialogRestoreTicket(false);
        setIsConfirmDialogObj(false);
    }

    const onClickOkConfirmDialog = async () => {
        setIsConfirmDialogObj(false);
        await handleDeleteTicket();
    }

    const onClickCloseConfirmDialogBackToArrival = () => {
        setIsShowDialogBackToArrivalTicket(false);
    }

    const onClickOkConfirmDialogBackToArrival = async () => {
        setIsShowDialogBackToArrivalTicket(false);
        await handleBackToArrivalTicket(props?.API,
            detailTicket,
            setDetailTicket,
            reloadTicketListByPanelType,
            getTicketListType(),
            setTriggerReloadTicket,
            currentUserDetail,
            setTriggerReloadMenu,
            setIsLoading,
            setIsOpenModalReloadPage,
            argsAll
        );
    }

    const setShowButtonEditTicket = (value) => {
        let formData = getValuesEditTicket()
        handlerShowButtonEditTicket(value, argsAll, formData)
    }

    const getDefaultValueOfField = (fieldData) => {

        if(fieldData.structure.UI === Constant.FIELD_UI.DROP_FILE){
            return fieldData.defaultValue
        }

        let defaultValue = currentPanelInitData.formData && currentPanelInitData.formData[fieldData.fieldId] ? currentPanelInitData.formData[fieldData.fieldId] : fieldData.defaultValue;

        return defaultValue
    }

    const ticketInvitationExternalB2B = useMemo(() => {
        let status = '';
        let classNameStatus = '';
        let messageInvitation = '';
        if (
            [
                Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK,
                Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER
            ].includes(detailTicket.ticketType)
        ) {
            messageInvitation = I18n.get('USER04MSG033')
            .replace('[corporationName]', detailTicket?.corporationOriginName || '')
            .replace('[projectName]', detailTicket.projectOriginName);

            switch (detailTicket.approveFlag) {
                case Constant.APPROVE_FLAG.INPROCESS:
                    status = Constant.B2B_INVITATION_STATUS.WAITING;
                    classNameStatus = 'watting';
                    break;
                case Constant.APPROVE_FLAG.APPROVE:
                    status = Constant.B2B_INVITATION_STATUS.APPROVED;
                    classNameStatus = 'approved';
                    break;
                case Constant.APPROVE_FLAG.REJECTED:
                    status = Constant.B2B_INVITATION_STATUS.REJECTED;
                    classNameStatus = 'rejected';
                    break;
                default:
                    break;
            }
        }
        return { status, classNameStatus, messageInvitation };
    }, [detailTicket]);

    const statusTicketInvitationGuestOrGuestDesk = useMemo(() => {
        let status = '';
        let classNameStatus = '';
        if (
            [
                Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
                Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT
            ].includes(detailTicket.ticketType)
        ) {
            let statusTicket = detailTicket.invitationFlag;
            switch (statusTicket) {
                case Constant.INVITATION_FLAG.INPROCESS:
                    status = Constant.B2B_INVITATION_STATUS.WAITING;
                    classNameStatus = 'watting';
                    break;
                case Constant.INVITATION_FLAG.INVITE_SUCCESS:
                    status = Constant.B2B_INVITATION_STATUS.APPROVED;
                    classNameStatus = 'approved';
                    break;
                case Constant.INVITATION_FLAG.INVITE_REJECTED:
                    status = Constant.B2B_INVITATION_STATUS.REJECTED;
                    classNameStatus = 'rejected';
                    break;
                default:
                    break;
            }
        }
        return { status, classNameStatus };
    }, [detailTicket]);

    const params = {
        panelList: panelList,
        setPanelList: setPanelList,
        triggerReload: setTriggerReloadTicket,
        API: props?.API,
        userDetail:currentUserDetail,
        setIsLoading,
        selectedTicket: detailTicket,
        corporationId: corporationDetail.id,
        currentProjectId,
        setIsOpenModalReloadPage,
        projectDetails,
        corporationDetail: corporationDetail
    }

    const TooltipInKnowledge = () => {
        const panelType = getPanelType();
        let toolTipTxt = '';
        if (
            [
                Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
            ]?.includes(panelType)
        ) {
            toolTipTxt = I18n.get('KNOWLITT001');
        }
        return toolTipTxt;
    };

    const isDisableBtnSaveTicket = () => {
        if (!isInputAllFieldRequiredWhenEditTicket(fieldListDefaultData, [...fileUploadList, ...fileUpdatedList], getValuesEditTicket) || !Utils.isEmptyObject(errorEditTicket)) {
            return true;
        }
        return !(isEdited && isEditTicket);
    }

    const renderButtonAnonymous = () => {
        if (detailTicket.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
            return (
                <div className="action-content">
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-outline-primary approve-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            detailTicket,
                            projectDetails,
                            corporationDetail,
                            true
                        )}
                        onClick={e =>
                            onSubmitApproveAnonymousQaFromLiveChat(
                                params,
                                reloadTicketListByPanelType
                            )
                        }
                    >
                        {I18n.get('CBOTBT005')}
                    </Button>
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-outline-light reject-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            detailTicket,
                            projectDetails,
                            corporationDetail,
                            false
                        )}
                        onClick={() => setIsShowDialogDeleteTicketFromLiveChat(true)}
                    >
                        {I18n.get('USER04BTN055')}
                    </Button>
                </div>
            );
        }
        return (
            <div className="action-content">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-outline-primary approve-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(detailTicket)}
                    onClick={e => approveAnonymousQaTicket(argsAll)}
                >
                    {I18n.get('USER04BTN054')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-hg32 btn-outline-light reject-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(detailTicket)}
                    onClick={e => rejectAnonymousQaTicket(detailTicket, argsAll)}
                >
                    {I18n.get('USER04BTN055')}
                </Button>
            </div>
        );
    };

    const isArchiveOrTrashView = useMemo(() => {
        return (
            (isDisplayButtonBackToArrival() &&
                getPanelType() !== Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL) ||
            ((isSoftDelete || isRejectTicketAnonymous) &&
                isGeneralUserWithGuest &&
                !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail))
        );
    }, [
        corporationDetail,
        detailTicket,
        getPanelType,
        isDisplayButtonBackToArrival,
        isGeneralUserWithGuest,
        isRejectTicketAnonymous,
        isSoftDelete
    ]);

    // Determine whether the callback button should be displayed
    const shouldShowCallbackButton = useMemo(() => {
        try {
            if (detailTicket.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
                return false;
            }
            
            const isDeletedOrArchiveTicket =
                isSoftDelete || detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;
            if (isDeletedOrArchiveTicket) {
                return false;
            }

            if (!telephoneCallStatus) {
                return false;
            }

            const metaData = Utils.convertJSONDataToObject(detailTicket?.metaData);
            const callType = metaData?.callType || '';
            const isVoiceCallTicket = callType === TelephoneConstant.CALL_TYPE.VOICE_CALL;
            // Phone tickets belong to one project. Shared voice tickets can be opened from BASE
            // even when the physical ticket is stored under the normal project.
            if (
                detailTicket?.affiliationProject !== selectedProject?.id &&
                !(
                    isVoiceCallTicket &&
                    isVoiceCallTicketAvailableInProject(metaData, detailTicket, selectedProject)
                )
            ) {
                return false;
            }

            if (metaData?.telephoneType === Constant.TICKET_PROPERTY.TRAINING) return false;

            const callDirection = metaData?.callDirection;

            const callbackableStatuses = [
                TelephoneConstant.TELEPHONE_CALL_STATUS.END_CALL,
                TelephoneConstant.TELEPHONE_CALL_STATUS.MISSING_CALL,
                TelephoneConstant.TELEPHONE_CALL_STATUS.CANCELLED_CALL
            ];

            // Check call direction and status together
            // INBOUND: END_CALL, MISSING_CALL or CANCELLED_CALL
            const isInboundCallbackable = 
                callDirection === TelephoneConstant.CALL_DIRECTION.INBOUND &&
                callbackableStatuses.includes(telephoneCallStatus);

            // OUTBOUND: END_CALL, MISSING_CALL or CANCELLED_CALL
            const isOutboundCallbackable = 
                callDirection === TelephoneConstant.CALL_DIRECTION.OUTBOUND &&
                callbackableStatuses.includes(telephoneCallStatus);

            if (!isInboundCallbackable && !isOutboundCallbackable) {
                return false;
            }

            const hasTelephonePermission = Utils.isEnableSettingTelephoneAgent(corporationDetail);
            if (!hasTelephonePermission) return false;

            if (!isVoiceCallTicket) {
                // Phone call retry requires Public Desk + project telephone setting.
                if (!Utils.isPublicDesk(selectedProject)) return false;
                if (!Utils.isProjectOnAiTelephoneAgent(selectedProject)) return false;
            }

            return true;
        } catch (error) {
            console.error('Error determining callback button visibility:', error);
            return false;
        }
    }, [
        detailTicket?.ticketType,
        detailTicket?.metaData,
        detailTicket?.affiliationProject,
        telephoneCallStatus,
        isArchiveOrTrashView,
        corporationDetail,
        selectedProject
    ]);

    const isDisabledAllField = useMemo(() => {
        const fields = fieldListDefaultData?.filter(
            field =>
                field?.sysField !== Constant.TICKET_DATA_ID.TICKET_ID && !Utils.isEmptyObject(field)
        );
        return fields?.every(
            i => i?.structure?.publicForCustomer === 2 || i?.hasEditFieldPermissions
        );
    }, [fieldListDefaultData]);

    const isShowHamburgerMenu = useMemo(() => {
        // Current logic for non-telephone tickets
        return (
            isDisplayIconKnowledge(argsAll, projectIdListUserIsB2C) ||
            isDisplayIconChat(argsAll) ||
            (!(
                (isAnonymousQAWaitingTicket ||
                    Utils.isAnonymousQAWaitingOrEndLiveChatTicket(detailTicket)) &&
                detailTicket.customer === Constant.ANONYMOUS_USER_ID
            ) &&
                isDisplayButtonCluster() &&
                ((isDisplayButtonArchivedTicket() &&
                    getPanelType() !== Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL) ||
                    isDisplayButtonSoftDeleteTicket())) ||
            isDisableButtonSoftDeleteTicketQAAnonymos(detailTicket) ||
            isDisplayButtonCompleteDeleteTicket(detailTicket) ||
            ((isSoftDelete || isRejectTicketAnonymous) &&
                isGeneralUserWithGuest &&
                !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail))
        );
    }, [
        argsAll,
        corporationDetail,
        detailTicket,
        detailTicket.ticketType,
        telephoneCallStatus,
        isHelpdeskPanel,
        getPanelType,
        isAnonymousQAWaitingTicket,
        isDisplayButtonArchivedTicket,
        isDisplayButtonCluster,
        isDisplayButtonSoftDeleteTicket,
        isGeneralUserWithGuest,
        isRejectTicketAnonymous,
        isSoftDelete,
        projectIdListUserIsB2C
    ]);

    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = Utils.getShareLinkImg({
            attachFile: openFileOption,
            dataShareLink: detailTicket.dataShareLink
        });

        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);
        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [detailTicket, openFileOption]);

    const getDisplayOutline = (outlineValue) =>
        Utils.isEmptyString(outlineValue) ? Constant.DEFAULT_TICKET_NO_TITLE : outlineValue;

    const TicketLinkItem = ({
        id,
        outlineValue,
        appendText,
        isDisableClick = false,
        onClick,
    }) => {
        const displayOutline = `${getDisplayOutline(outlineValue)}${appendText || ''}`;
    
        return (
            <li>
                <Tooltip title={displayOutline}>
                    <div
                        className={`ticket-link-detail ${
                            isDisableClick ? 'ticket-link-detail-disabled' : ''
                        }`}
                        onClick={() => {
                            if (isDisableClick) return;
                            onClick?.(id, outlineValue);
                        }}
                    >
                        {displayOutline}
                    </div>
                </Tooltip>
            </li>
        );
    };
    
    const TicketFieldWrapper = ({ label, children }) => (
        <div className="form-addTicket" data-cy="detail-ticket-field">
            <label className="form-addTicket-label">{label}</label>
            <div className="form-addTicket-input">
                <div className="lstLink">
                    <ul>{children}</ul>
                </div>
            </div>
        </div>
    );

    const resolveEvaluatorOptionFromAssignList = (selectedId, selectedLabel = '') => {
        if (Utils.isEmptyString(selectedId) || Utils.isEmptyArray(assignList)) {
            return null;
        }

        if (!Utils.isEmptyString(selectedLabel)) {
            const exactMatch = assignList.find(
                user => user.id === selectedId && user.fullName === selectedLabel
            );
            if (exactMatch) return exactMatch;

            if (selectedLabel !== Constant.OPTION_ASSIGNEE_ME) {
                const nonMeMatch = assignList.find(
                    user =>
                        user.id === selectedId &&
                        user.fullName !== Constant.OPTION_ASSIGNEE_ME
                );
                if (nonMeMatch) return nonMeMatch;
            }
        }

        return assignList.find(user => user.id === selectedId) || null;
    };

    const getEvaluatorFallbackLabel = (value, selectedId) => {
        const parsedValue = Utils.convertJSONDataToObject(value);
        if (!Array.isArray(parsedValue) || Utils.isEmptyArray(parsedValue)) {
            return selectedId;
        }

        const selectedItem = parsedValue.find(item => {
            if (typeof item === 'string') {
                return item === selectedId;
            }
            return item?.value === selectedId || item?.id === selectedId;
        });

        if (typeof selectedItem === 'string') {
            return selectedItem;
        }
        return selectedItem?.title || selectedItem?.fullName || selectedId;
    };

    const getTelephoneEvaluatorSelection = (fieldData) => {
        const editingFormValue = getValuesEditTicket(fieldData.fieldId);
        const panelFormValue = currentPanelInitData?.formData?.[fieldData.fieldId];
        const parsedEditingFormValue = Utils.convertJSONDataToObject(editingFormValue);
        const isViewMode = displayMode === Constant.DISPLAY_MODE.VIEW;
        const editedFieldIds = [
            ...new Set([...(currentTabData?.listFieldEdited || []), ...listFieldEdited])
        ];
        const shouldUseTransientSelection =
            !isViewMode && editedFieldIds.includes(fieldData.fieldId);

        // User explicitly chose blank in current edit session.
        if (
            shouldUseTransientSelection &&
            Array.isArray(parsedEditingFormValue) &&
            parsedEditingFormValue.length === 0
        ) {
            return {
                selectedId: '',
                selectedOption: null
            };
        }

        const selectedFromEditing = shouldUseTransientSelection
            ? getEvaluatorSelectionMeta(editingFormValue)
            : null;
        const selectedFromPanel = shouldUseTransientSelection
            ? getEvaluatorSelectionMeta(panelFormValue)
            : null;
        const selectedFromTicket = getEvaluatorSelectionMeta(fieldData.defaultValue);
        const selectedMeta =
            selectedFromEditing || selectedFromPanel || selectedFromTicket || null;
        const selectedId = selectedMeta?.id || '';
        const selectedLabel = selectedMeta?.label || '';
        const selectedLabelFromUserDetail = evaluatorUserNameMap?.[selectedId] || '';

        if (Utils.isEmptyString(selectedId)) {
            return {
                selectedId: '',
                selectedOption: null
            };
        }

        if (!shouldUseTransientSelection) {
            const fallbackFromTicket = getEvaluatorFallbackLabel(
                fieldData.defaultValue,
                selectedId
            );
            const fallbackFromCurrentValue = getEvaluatorFallbackLabel(
                fieldData.value,
                selectedId
            );
            const selectedDisplayName =
                selectedLabelFromUserDetail ||
                (selectedLabel !== selectedId ? selectedLabel : '') ||
                (fallbackFromTicket !== selectedId ? fallbackFromTicket : '') ||
                (fallbackFromCurrentValue !== selectedId ? fallbackFromCurrentValue : '') ||
                selectedId;
            return {
                selectedId,
                selectedOption: {
                    id: selectedId,
                    fullName: selectedDisplayName,
                    lastName: { jp: { A: 'F', text: selectedDisplayName } }
                }
            };
        }

        const selectedInAssignList = resolveEvaluatorOptionFromAssignList(
            selectedId,
            selectedLabelFromUserDetail || selectedLabel
        );
        if (selectedInAssignList) {
            return {
                selectedId,
                selectedOption: selectedInAssignList
            };
        }

        const fallbackFromEditing = getEvaluatorFallbackLabel(editingFormValue, selectedId);
        if (fallbackFromEditing !== selectedId) {
            return {
                selectedId,
                selectedOption: {
                    id: selectedId,
                    fullName: fallbackFromEditing,
                    lastName: { jp: { A: 'F', text: fallbackFromEditing } }
                }
            };
        }

        const fallbackFromPanel = getEvaluatorFallbackLabel(panelFormValue, selectedId);
        const fallbackLabel =
            fallbackFromPanel === selectedId
                ? getEvaluatorFallbackLabel(fieldData.defaultValue, selectedId)
                : fallbackFromPanel;
        return {
            selectedId,
            selectedOption: {
                id: selectedId,
                fullName: fallbackLabel,
                lastName: { jp: { A: 'F', text: fallbackLabel } }
            }
        };
    };

    const convertEvaluatorSelectionToFormValue = (selectedList = []) => {
        if (Utils.isEmptyArray(selectedList)) return [];

        // Keep behavior consistent with personInCharge: always use the latest selected option.
        const latestSelectedUser = selectedList[selectedList.length - 1];
        if (
            !latestSelectedUser ||
            Utils.isEmptyString(latestSelectedUser.id) ||
            latestSelectedUser.id === Constant.OPTION_UNASSIGNEE.KEY
        ) {
            return [];
        }

        return [
            {
                value: latestSelectedUser.id,
                title: latestSelectedUser.fullName || latestSelectedUser.id
            }
        ];
    };
    
    const renderPersonInCharge = (ctx) => {
        const {
            fieldData,
        } = ctx;
    
        if (!canTicketHasPIC(detailTicket)) {
            return <></>;
        }
    
        return (
            <AssigneeUI
                {...argsAll}
                data={fieldData}
                ticketDetail={detailTicket}
                assignList={assignList}
                assigneeUserData={currentAssigneeUserData}
                listFieldEdited={listFieldEdited}
                isGeneralUser={isGeneralUser}
                isManager={isProjectManager}
                isHelpDesk={isHelpDesk}
                isShowIconCopyFieldId={false}
                isDisplayButtonEditTicket={isDisplayButtonEditTicket()}
                isDisableEdit={
                    isDisableEdit ||
                    displayMode === Constant.DISPLAY_MODE.VIEW
                }
                assigneeDefault={{
                    ...detailTicket?.personInChargeInfo,
                    assigneeIcon:
                        detailTicket?.personInChargeInfo?.shortName,
                    assigneeFullName:
                        detailTicket?.personInChargeInfo?.fullName,
                }}
                setNewAssignee={setNewAssignee}
                setIsEdited={setIsEdited}
                setOnChangeEdit={setOnChangeEdit}
                onChangeEdit={onChangeEdit}
                setCurrentAssigneeUserData={setCurrentAssigneeUserData}
                setNewAssigneeData={setNewAssigneeData}
                setListFieldEdited={setListFieldEdited}
                setIsEditTicket={setIsEditTicket}
            />
        );
    };    

    const renderTelephoneEvaluator = (ctx) => {
        const { fieldData } = ctx;
        const fieldLabel = fieldData.fieldLabel
            ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, fieldData.fieldLabel)
            : TelephoneConstant.SYSTEM_FIELD_LABEL.TELEPHONE_EVALUATOR;

        const { selectedId, selectedOption } = getTelephoneEvaluatorSelection(fieldData);
        const isDisableEvaluatorEdit =
            isDisableEdit ||
            displayMode === Constant.DISPLAY_MODE.VIEW ||
            !isDisplayButtonEditTicket();

        return (
            <AssigneeFieldCommonUI
                assignList={assignList}
                onSelectNewAssign={(selectedList) => {
                    registerEditTicket(fieldData.fieldId);
                    const formattedValue = convertEvaluatorSelectionToFormValue(selectedList);
                    setValueEditTicket(fieldData.fieldId, formattedValue);
                    setIsEdited(true);
                    setIsEditTicket(true);
                    setOnChangeEdit(prev => !prev);
                    setListFieldEdited(prev =>
                        prev.includes(fieldData.fieldId) ? prev : [...prev, fieldData.fieldId]
                    );
                }}
                fieldId={fieldData.id}
                isShowIconCopyFieldId={false}
                disable={isDisableEvaluatorEdit}
                uniqueId={`${props.panelId}-${props.tabId}-${fieldData.id}-telephone-evaluator`}
                selectedAssignee={selectedId}
                selectedAssigneeOption={selectedOption}
                label={fieldLabel}
                isLoading={isLoading}
                isEllipsisField={true}
            />
        );
    };

    const renderEscalationOriginCustomer = (ctx) => {
        if (
            !isDisplayTicketParent ||
            (isHelpDesk && !Utils.isEmptyString(ticketParent?.deletedAt))
        ) {
            return <></>;
        }
    
        const appendText = !Utils.isEmptyString(ticketParent?.deletedAt)
            ? `[${I18n.get('COMMSG069')}]`
            : '';
    
        return (
            <TicketFieldWrapper label={I18n.get('USER04LB013')}>
                <TicketLinkItem
                    id={ticketParent?.id}
                    outlineValue={ticketParent?.outline}
                    appendText={appendText}
                    isDisableClick={!isDisableDeskService}
                    onClick={(id, ticketOutline) =>
                        viewTicketChildAndParent(id, ticketOutline, false)
                    }
                />
            </TicketFieldWrapper>
        );
    };    

    const renderEscalationTarget = (ctx) => {
        if (!isHelpDesk || Utils.isEmptyArray(listTicketChild)) {
            return <></>;
        }
    
        return (
            <TicketFieldWrapper label={I18n.get('USER04LB016')}>
                {listTicketChild.map(
                    (ticket) =>
                        ticket?.id && (
                            <TicketLinkItem
                                key={ticket.id}
                                id={ticket.id}
                                outlineValue={ticket.outline}
                                onClick={(id, ticketOutline) =>
                                    viewTicketChildAndParent(id, ticketOutline, true)
                                }
                            />
                        )
                )}
            </TicketFieldWrapper>
        );
    };
    
    const TELEPHONE_TICKET_LINK_FALLBACK_LABELS = {
        [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RELATED_TICKETS]:
            TelephoneConstant.TELEPHONE_FIELD_LABEL.TELEPHONE_RELATED_TICKETS,
        [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.NEXT_CALL]:
            TelephoneConstant.TELEPHONE_FIELD_LABEL.TELEPHONE_NEXT_CALL,
    };

    const renderTelephoneTicketLink = (ctx) => {
        const {
            fieldData
        } = ctx;

        const linkedTicket = fieldData?.value ? Utils.convertJSONDataToObject(fieldData?.value) : {};
        if (!isHelpDesk || !linkedTicket?.id) {
            return <></>;
        }
    
        const label =
            fieldData.fieldLabel
                ? Utils.getTextByLanguage(
                      Constant.LANGUAGE_TYPE.JP,
                      fieldData.fieldLabel
                  )
                : TELEPHONE_TICKET_LINK_FALLBACK_LABELS[fieldData.sysField] || '';
    
        return (
            <TicketFieldWrapper label={label}>
                <TicketLinkItem
                    id={linkedTicket.id}
                    outlineValue={linkedTicket.outline}
                    onClick={(id, ticketOutline) =>
                        viewTicketChildAndParent(id, ticketOutline, false)
                    }
                />
            </TicketFieldWrapper>
        );
    };

    const SYS_FIELD_RENDERERS = {
        personInCharge: renderPersonInCharge,
        escalationOriginCustomer: renderEscalationOriginCustomer,
        escalationTarget: renderEscalationTarget,
        [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.EVALUATOR]:
            renderTelephoneEvaluator,
        [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RELATED_TICKETS]:
            renderTelephoneTicketLink,
        [TelephoneConstant.TELEPHONE.SYSTEM_FIELD.NEXT_CALL]:
            renderTelephoneTicketLink,
    };

    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap">
                    <div className="col2">
                        {/* Callback button for a telephone ticket - View mode */}
                        {displayMode === Constant.DISPLAY_MODE.VIEW && 
                            !isArchiveOrTrashView && 
                            shouldShowCallbackButton && (
                            <div
                                className="itemAddticket edit-ticket-btn"
                                data-cy="detail-ticket-btn-frame"
                            >
                                <div className="wrap-btn-add">
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32 btn-callback"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleCallbackButtonClick}
                                        disabled={isDisableCallBackButton(detailTicket?.metaData, voiceStatus)}
                                    >
                                        {I18n.get('CALL_BACK')}
                                    </Button>
                                </div>
                            </div>
                        )}
                        {(displayMode === Constant.DISPLAY_MODE.EDIT || isArchiveOrTrashView) && (
                            <div
                                className="itemAddticket edit-ticket-btn"
                                data-cy="detail-ticket-btn-frame"
                            >
                                <div className="wrap-btn-add">
                                    {/* Callback button for a telephone ticket - Edit mode */}
                                    {!isArchiveOrTrashView && shouldShowCallbackButton && (
                                        <Button
                                            className="btn-send btn-outline-primary btn-hg32 btn-callback"
                                            variant="contained"
                                            color="primary"
                                            onClick={handleCallbackButtonClick}
                                            disabled={isDisableCallBackButton(detailTicket?.metaData, voiceStatus)}
                                        >
                                            {I18n.get('CALL_BACK')}
                                        </Button>
                                    )}
                                    {!isArchiveOrTrashView && (
                                        <Button
                                            className="btn-send btn-outline-primary btn-hg32"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (!isEdited) {
                                                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                                                } else {
                                                    setDisplayPopupConfirmCancel(true);
                                                }
                                            }}
                                        >
                                            編集破棄
                                        </Button>
                                    )}
                                    {!(
                                        (isAnonymousQAWaitingTicket ||
                                            Utils.isAnonymousQAWaitingOrEndLiveChatTicket(
                                                detailTicket
                                            )) &&
                                        detailTicket.customer === Constant.ANONYMOUS_USER_ID
                                    ) &&
                                        isDisplayButtonCluster() && (
                                            <>
                                                {isDisplayButtonBackToArrival() &&
                                                    getPanelType() !==
                                                        Constant.PANEL_TYPE
                                                            .CUSTOMER_TICKET_DETAIL && (
                                                        <Button
                                                            className="btn-send btn-outline-primary btn-hg32 btn-back-to-arrival"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={e =>
                                                                setIsShowDialogBackToArrivalTicket(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            {I18n.get('HELPDESK_BACK_TO_NEW_SUPPORT')}
                                                        </Button>
                                                    )}
                                                {isDisplayButtonEditTicket() && (
                                                    <Button
                                                        className="btn-send btn-primary btn-hg32"
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={isDisableBtnSaveTicket()}
                                                        onClick={handleSubmitEditTicket(
                                                            handleEditTicketSubmit
                                                        )}
                                                        data-cy="btn-submit-add-ticket"
                                                    >
                                                        保存
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                    {renderBtnCompletedDeleteAndRestoreTicket()}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="scrollBar-main change-bodR">
                        {isSoftDelete && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        本チケットは削除した日付から30日以内で復元可能です。
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        に自動的に完全削除されます。
                                    </p>
                                </div>
                            </div>
                        )}

                        <div className={`titleTicket ${!isQAPanel && 'title-ticket-knowledge'}`}>
                            {!isQAPanel && (
                                <TagDefaultBookmark
                                    className={'ticket-knowledge-detail-tag-default'}
                                    isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                    ticketKnowledge={detailTicket}
                                    corporationDetail={corporationDetail}
                                    projectInuseDetail={selectedProject}
                                    userDetail={currentUserDetail}
                                    setTriggerReloadKnowledgeListPanel={reloadTicketListByPanelType}
                                    bookmarkTargetType={bookmarkTargetType}
                                />
                            )}

                            {titleLineNumber === 2 ? (
                                <label
                                    className={`titleDisplay titleTicket-titlev2 ${!isQAPanel &&
                                        'title-knowledge-display'}`}
                                >
                                    {!Utils.isEmptyString(outline)
                                        ? outline
                                        : '[概要 (現在未記入)]'}
                                </label>
                            ) : (
                                <Tooltip
                                    title={
                                        !Utils.isEmptyString(outline)
                                            ? outline
                                            : '[概要 (現在未記入)]'
                                    }
                                >
                                    <label
                                        className={`titleDisplay titleTicket-titlev2 title-clamp ${!isQAPanel &&
                                            'title-knowledge-display'}`}
                                    >
                                        {!Utils.isEmptyString(outline)
                                            ? outline
                                            : '[概要 (現在未記入)]'}
                                    </label>
                                </Tooltip>
                            )}
                            <div
                                className="titleTicket-btn"
                                style={{ gap: 5, alignItems: 'center' }}
                            >
                                {displayMode === Constant.DISPLAY_MODE.VIEW &&
                                    !isShowInvitationStatus(detailTicket) &&
                                    !isArchiveOrTrashView &&
                                    !(
                                        ((isAnonymousQAWaitingTicket &&
                                            !Utils.isAnonymousQATicketFromLiveChat(detailTicket)) ||
                                            Utils.isAnonymousQAWaitingOrEndLiveChatTicket(
                                                detailTicket
                                            )) &&
                                        isHelpDesk
                                    ) &&
                                    !isDisableButtonSoftDeleteTicketQAAnonymos(detailTicket) &&
                                    !isDisabledAllField &&
                                    isDisplayButtonEditTicket() && (
                                        <IconButton
                                            onClick={() =>
                                                setDisplayMode(Constant.DISPLAY_MODE.EDIT)
                                            }
                                            className="itemNav"
                                        >
                                            <img src="/assets/image/icon-edit-mode.svg" alt="" />
                                        </IconButton>
                                    )}
                                {!Utils.isEmptyObject(detailTicket?.dataShareLink) && (
                                    <CopyShortLink
                                        detailTicket={detailTicket}
                                        isGeneralUser={isGeneralUser}
                                        corporationDetail={corporationAffiliationTicket}
                                    />
                                )}
                                {isShowHamburgerMenu && (
                                    <IconButton
                                        onClick={e =>
                                            setAnchorShowMoreActionsPopover(e.currentTarget)
                                        }
                                        className="itemNav"
                                    >
                                        <img src="/assets/image/icon-more-panel.svg" alt="" />
                                    </IconButton>
                                )}
                            </div>
                        </div>

                        {!isQAPanel && (
                            <div className="ticket-bookmark-info">
                                <Bookmark
                                    isTicketBookmark={true}
                                    isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                    ticketKnowledge={detailTicket}
                                    panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL}
                                    isShowEdit={true}
                                    bookmarkPopupContainerClassName={
                                        'reset-position-bookmark-popup-container'
                                    }
                                />
                                <div className="ticket-bookmark-info-wrap">
                                    <div className="ticket-bookmark-info-text-wrap">
                                        <TaggedBookmarkListName
                                            bookmarkListText={detailTicket?.bookmarkListText}
                                            className="ticket-bookmark-info-text"
                                        />
                                    </div>
                                    <UserTagPrivateBookmarkCount ticketKnowledge={detailTicket} />
                                </div>
                            </div>
                        )}

                        {((isAnonymousQAWaitingTicket &&
                            !Utils.isAnonymousQATicketFromLiveChat(detailTicket)) ||
                            Utils.isAnonymousQAWaitingOrEndLiveChatTicket(detailTicket)) &&
                            isHelpDesk && (
                                <div className="approve-reject-anonymous-qa-content">
                                    <div className="text-content">
                                        組織
                                        {Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            corporationDetail.name
                                        )}
                                        のゲストカスタマープロジェクトに未登録のユーザです。却下すると、チケットは削除されます。
                                    </div>
                                    {renderButtonAnonymous()}
                                </div>
                            )}

                        {isShowInvitationExternalHeader(argsAll) && (
                            <div className="invitation-header-box">
                                <div className="invitation-message">
                                    {ticketInvitationExternalB2B.messageInvitation}
                                </div>
                                <div className="invitation-button">
                                    <Button
                                        disabled={!isGeneralUserWithGuest}
                                        className="btn-approve"
                                        onClick={() =>
                                            onClickApproveRejectExternal(
                                                Constant.APPROVE_FLAG.APPROVE,
                                                argsAll
                                            )
                                        }
                                    >
                                        {I18n.get('USER04BTN054')}
                                    </Button>
                                    <Button
                                        disabled={!isGeneralUserWithGuest}
                                        className="btn-reject"
                                        onClick={() =>
                                            onClickApproveRejectExternal(
                                                Constant.APPROVE_FLAG.REJECTED,
                                                argsAll
                                            )
                                        }
                                    >
                                        {I18n.get('USER04BTN055')}
                                    </Button>
                                </div>
                            </div>
                        )}

                        <div
                            className="addTicket addTicket-detail footer"
                            data-cy="detail-ticket-content"
                        >
                            <ErrorMessageHeader message={errorMessageHeader} />
                            {detailTicket.ticketType !== Constant.TICKET_TYPE.TASK && 
                                detailTicket.ticketType !== Constant.TICKET_TYPE.TELEPHONE && (
                                <div className="target-ticket-detail">
                                    <div
                                        className="target-ticket-detail-child"
                                        data-cy="detail-ticket-field"
                                    >
                                        <label className="form-addTicket-label">問い合わせ元</label>
                                        <div className="project-target">
                                            <OverFlowTooltipWithTabsMui
                                                value={detailTicket.projectOriginName}
                                                className="project-target-text"
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">➜</div>
                                    <div
                                        className="target-ticket-detail-child"
                                        data-cy="detail-ticket-field"
                                    >
                                        {detailTicket.ticketType ===
                                            Constant.TICKET_TYPE.BROADCAST_PARENT ||
                                        detailTicket.ticketType ===
                                            Constant.TICKET_TYPE.BROADCAST_CHILD ? (
                                            <OverFlowTooltipWithTabsMui
                                                value="発行先プロジェクト(ユーザー)"
                                                className="project-target-text"
                                            />
                                        ) : (
                                            <p className="form-addTicket-label">問い合わせ先</p>
                                        )}
                                        <div className="project-target">
                                            {detailTicket.ticketType ===
                                            Constant.TICKET_TYPE.BROADCAST_PARENT ? (
                                                <OverFlowTooltipWithTabsMui
                                                    value={detailTicket.customerName?.trim()}
                                                    className="project-target-text"
                                                />
                                            ) : (
                                                <OverFlowTooltipWithTabsMui
                                                    value={
                                                        detailTicket.ticketType ===
                                                        Constant.TICKET_TYPE.BROADCAST_CHILD
                                                            ? detailTicket.customerName
                                                            : detailTicket.projectTargetName
                                                    }
                                                    className="project-target-text"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {Utils.isAnonymousQATicket(detailTicket) && (
                                <>
                                    <div className="target-ticket-detail target-ticket-name">
                                        <div
                                            className="target-ticket-detail-child"
                                            data-cy="detail-ticket-field"
                                        >
                                            <label className="form-addTicket-label">
                                                {I18n.get('INQUIRY-USER-NAME')}
                                            </label>
                                            <div className="project-target">
                                                <Tooltip title={renderUserName(detailTicket)}>
                                                    <label className="user-data-text user-data-text-clamp">
                                                        {renderUserName(detailTicket)}
                                                    </label>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="target-ticket-detail target-ticket-name">
                                        <div
                                            className="target-ticket-detail-child"
                                            data-cy="detail-ticket-field"
                                        >
                                            <label className="form-addTicket-label">
                                                {I18n.get('INQUIRY-USER-EMAIL_ADDRESS')}
                                            </label>
                                            <div className="project-target">
                                                <Tooltip
                                                    title={
                                                        detailTicket?.anonymousUserInfo?.mailAddress
                                                    }
                                                >
                                                    <label className="user-data-text user-data-text-clamp">
                                                        {
                                                            detailTicket?.anonymousUserInfo
                                                                ?.mailAddress
                                                        }
                                                    </label>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            {detailTicket.ticketType === Constant.TICKET_TYPE.DELEGATE && (
                                <div className="form-addTicket" data-cy="detail-ticket-field">
                                    <label className="form-addTicket-label">代理投稿者</label>
                                    <div className="form-addTicket-input">
                                        <TextField
                                            className="form-control form-control-wrapInput form-control-hg40 proxied-user-name"
                                            variant="outlined"
                                            inputProps={{ className: 'fields-disabled' }}
                                            disabled
                                            value={detailTicket?.proxiedUserName}
                                        />
                                    </div>
                                </div>
                            )}

                            <FormProvider {...validateEditTicket}>
                                {!Utils.isEmptyArray(fieldListDefaultData) &&
                                    fieldListDefaultData
                                        ?.filter(
                                            field =>
                                                field.sysField !==
                                                    Constant.TICKET_DATA_ID.TICKET_ID &&
                                                !Utils.isEmptyObject(field)
                                        )
                                        .map((fieldData, i) => {
                                            if (
                                                fieldData.type == Constant.FORM_TYPE.FIELD_WORKFLOW
                                            ) {
                                                const isTelephoneWorkflowField =
                                                    fieldData.sysField ===
                                                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD
                                                        .CALL_STATUS;
                                                const isStatusReadOnlyInTelephoneTicket =
                                                    detailTicket?.ticketType ===
                                                        Constant.TICKET_TYPE.TELEPHONE &&
                                                    !isTelephoneWorkflowField;
                                                const workflowStatusData = isTelephoneWorkflowField
                                                    ? telephoneStatusOfTicket
                                                    : statusOfTicket;

                                                if (
                                                    !Utils.isEmptyObject(workflowStatusData) &&
                                                    canTicketHasStatus(detailTicket, isHelpDesk)
                                                ) {
                                                    const WorkflowStatusComponent =
                                                        isTelephoneWorkflowField
                                                            ? TelephoneCallStatusFieldUI
                                                            : StatusFieldUI;
                                                    return (
                                                        <WorkflowStatusComponent
                                                            key={i}
                                                            name={fieldData.fieldId}
                                                            ticketDetail={detailTicket}
                                                            isHelpDesk={isHelpDesk}
                                                            {...(isTelephoneWorkflowField
                                                                ? { panelStatusKey: Constant.PANEL_STATUS_KEY.TELEPHONE_WORKFLOW }
                                                                : {})}
                                                            setNewStatusData={
                                                                !isTelephoneWorkflowField
                                                                    ? setNewStatusData
                                                                    : undefined
                                                            }
                                                            setNewStatusOfTicket={
                                                                !isTelephoneWorkflowField
                                                                    ? setNewStatusOfTicket
                                                                    : undefined
                                                            }
                                                            setIsEdited={setIsEdited}
                                                            setOnChangeEdit={setOnChangeEdit}
                                                            onChangeEdit={onChangeEdit}
                                                            currentItemData={
                                                                workflowStatusData.currentItemData
                                                            }
                                                            statusDetail={workflowStatusData.status}
                                                            corporationId={
                                                                detailTicket.affiliationOrganization
                                                            }
                                                            setListFieldEdited={setListFieldEdited}
                                                            listFieldEdited={listFieldEdited}
                                                            fieldData={fieldData}
                                                            setIsEditTicket={setIsEditTicket}
                                                            selectedAssigneeUserId={newAssignee}
                                                            {...argsAll}
                                                            isDisableEdit={
                                                                isDisableEdit ||
                                                                isStatusReadOnlyInTelephoneTicket ||
                                                                displayMode ===
                                                                    Constant.DISPLAY_MODE.VIEW
                                                            }
                                                        />
                                                    );
                                                }
                                                return <></>;
                                            }

                                            if (
                                                [
                                                    Constant.SYSTEM_FIELD.PERSON_IN_CHARGE,
                                                    Constant.SYSTEM_FIELD
                                                        .ESCALATION_ORIGIN_CUSTOMER,
                                                    Constant.SYSTEM_FIELD.ESCALATION_TARGET,
                                                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD
                                                        .EVALUATOR,
                                                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD
                                                        .RELATED_TICKETS,
                                                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD
                                                        .NEXT_CALL
                                                ].includes(fieldData.sysField)
                                            ) {
                                                const fieldRenderContext = {
                                                    fieldData
                                                };
                                                return (
                                                    SYS_FIELD_RENDERERS[fieldData.sysField]?.(
                                                        fieldRenderContext
                                                    ) ?? null
                                                );
                                            }

                                            return (
                                                <RenderFieldUI
                                                    API={props?.API}
                                                    UI={fieldData.structure.UI}
                                                    label={
                                                        fieldData.fieldLabel
                                                            ? Utils.getTextByLanguage(
                                                                  Constant.LANGUAGE_TYPE.JP,
                                                                  fieldData.fieldLabel
                                                              )
                                                            : ''
                                                    }
                                                    errorlist={errorEditTicket}
                                                    name={fieldData.fieldId}
                                                    data={fieldData}
                                                    defaultValue={getDefaultValueOfField(fieldData)}
                                                    triggerValidate={triggerValidate}
                                                    isEdited={isEdited}
                                                    setIsEdited={setIsEdited}
                                                    setOnChangeEdit={setOnChangeEdit}
                                                    onChangeEdit={onChangeEdit}
                                                    setListFieldEdited={setListFieldEdited}
                                                    listFieldEdited={listFieldEdited}
                                                    // Drop file props
                                                    fileUploadList={fileUploadList}
                                                    setFileUploadList={setFileUploadList}
                                                    register={registerEditTicket}
                                                    setValue={setValueEditTicket}
                                                    clearErrors={clearErrors}
                                                    setFileUpdatedList={setFileUpdatedList}
                                                    fileUpdatedList={fileUpdatedList}
                                                    getValues={getValuesEditTicket}
                                                    autoFillObject={autoFillObject}
                                                    setAutoFillObject={setAutoFillObject}
                                                    editTicket={true}
                                                    detailTicket={detailTicket}
                                                    isExChangeTagField={isExChangeTagField}
                                                    setIsExChangeTagField={setIsExChangeTagField}
                                                    {...argsAll}
                                                    viewFromProjectOfEscalateTicket={
                                                        viewFromProjectOfEscalateTicket
                                                    }
                                                    flagReset={flagReset}
                                                    isSoftDelete={isSoftDelete}
                                                    isDisableOnBlur={true}
                                                    setShowButtonEditTicket={
                                                        setShowButtonEditTicket
                                                    }
                                                    isLoading={isLoading}
                                                    setIsLoading={setIsLoading}
                                                    isShowIconCopyFieldId={false}
                                                    onClickUrlViewTicket={onClickUrlViewTicket}
                                                    hasEditFieldPermissions={hasEditPermissionWithSpecialCase(
                                                        fieldData,
                                                        detailTicket,
                                                        selectedProject,
                                                        isProjectManager,
                                                        displayMode
                                                    )}
                                                    displayMode={displayMode}
                                                    setFlagReset={setFlagReset}
                                                />
                                            );
                                        })}

                                <AttachFileChatPost
                                    detailTicket={detailTicket}
                                    fieldListDefaultData={fieldListDefaultData}
                                    setOpenPreviewImage={setOpenPreviewImage}
                                    setOpenFileOption={setOpenFileOption}
                                    setOpenOption={setOpenOption}
                                />
                            </FormProvider>

                            {isShowInvitationStatus(detailTicket) && (
                                <div className="ticket-status">
                                    <label className="ticket-status-label">
                                        {I18n.get('KNOWCRLB018')}
                                        <span className="required">*</span>
                                    </label>
                                    <div
                                        className={`ticket-status-wrap ${ticketInvitationExternalB2B.classNameStatus}`}
                                    >
                                        <span>{ticketInvitationExternalB2B.status}</span>
                                    </div>
                                </div>
                            )}

                            {[
                                Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
                                Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT
                            ].includes(detailTicket.ticketType) && (
                                <FieldInvitedPartnerB2b
                                    setValue={setValueEditTicket}
                                    getValues={getValuesEditTicket}
                                    clearErrors={clearErrors}
                                    errorlist={errorEditTicket}
                                    setErrorCreateTicket={setErorsEditTicket}
                                    register={registerEditTicket}
                                    defaultMaxGeneralId={
                                        parseInt(detailTicket?.invitationInfo?.maxGeneralId) || 1
                                    }
                                    defaultSubdomainInvited={
                                        detailTicket?.invitationInfo?.subDomainInvited || ''
                                    }
                                    disabled={true}
                                    ticketType={detailTicket?.ticketType}
                                    numberGeneralIdLeft={
                                        detailTicket?.invitationInfo?.numberGeneralIdLeft
                                    }
                                />
                            )}

                            {isShowInvitationGuestOrGuestDeskStatus(detailTicket) && (
                                <div className="ticket-status">
                                    <label className="ticket-status-label">
                                        {I18n.get('KNOWCRLB018')}
                                        <span className="required">*</span>
                                    </label>
                                    <div
                                        className={`ticket-status-wrap ${statusTicketInvitationGuestOrGuestDesk.classNameStatus}`}
                                    >
                                        <span>{statusTicketInvitationGuestOrGuestDesk.status}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="detail-ticketKnowledge-info">
                            <div className="detailTicket-footer">
                                <div className="detail-ticketKnowledge-form">
                                    <div className="detail-ticketKnowledge-form-label">
                                        {I18n.get('LABEL-FORMAT-NAME')}
                                    </div>
                                    <OverFlowTooltipWithTabsMui
                                        value={detailTicket?.usingFormName}
                                    />
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        {I18n.get('CM-LABEL-FORMAT-ID')} :
                                        <span
                                            className="id-detail-ticket-copy"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(formDetail?.id)
                                                    .then(() => {})
                                                    .catch(err => {});
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span className="field-form-id">{formDetail?.id}</span>
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        投稿日時：<span>{detailTicket?.createTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        投稿ユーザー：
                                        <Tooltip title={detailTicket?.createrUserName}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {detailTicket?.createrUserName}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>

                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        更新日時：
                                        <span>
                                            {
                                                Utils.getUpdatedTimeTicket(isHelpDesk, detailTicket)
                                                    .updatedTime
                                            }
                                        </span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        更新ユーザー：
                                        <Tooltip
                                            title={showUpdatorDetailTicket(
                                                isHelpDesk,
                                                detailTicket
                                            )}
                                        >
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {showUpdatorDetailTicket(isHelpDesk, detailTicket)}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="id-detail-ticket-footer">
                                    <span className="id-detail-ticket-title">
                                        {I18n.get('USER04LB004')} :
                                    </span>
                                    <span
                                        className="id-detail-ticket-copy"
                                        onClick={async () => {
                                            navigator.clipboard
                                                .writeText(
                                                    detailTicket?.ticketType !==
                                                        Constant.TICKET_TYPE.BROADCAST_CHILD
                                                        ? detailTicket?.id
                                                        : detailTicket?.parent
                                                )
                                                .then(() => {})
                                                .catch(e => console.log('copy ticketId e :>> ', e));
                                        }}
                                    >
                                        <img src="/assets/image/icon-copy.svg" alt="" />
                                    </span>
                                    <span id="ticketId">
                                        {detailTicket?.ticketType !==
                                        Constant.TICKET_TYPE.BROADCAST_CHILD
                                            ? detailTicket?.id
                                            : detailTicket?.parent}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <DialogConfirmCancelEditTicket
                        saveAndCancel={saveAndCancel}
                        isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                        setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                        setCloseTabIdState={setCloseTabIdState}
                        detailTicket={detailTicket}
                        // Draft
                        submitSentDraft={handleSubmitEditTicket(handleSentTicketFromDraft)}
                        handleSaveDraftTicket={handleSaveDraftTicket}
                        handleResetFormData={handleResetFormData}
                        handleCancelTicket={() => {
                            setIsEdited(false);
                            removePanelInitData(
                                props?.panelId,
                                props?.tabId,
                                panelInitData,
                                setPanelInitData
                            );
                            const resetIsEdited = false;
                            handleCloseTab(resetIsEdited);
                        }}
                    />

                    <DialogConfirmRejectAnonymousQaTicket
                        {...argsAll}
                        parentPanelScreen={Constant.PANEL_TYPE.DETAIL_TICKET}
                    />
                    <DialogConfirmAcceptAnonymousQaTicket
                        {...argsAll}
                        parentPanelScreen={Constant.PANEL_TYPE.DETAIL_TICKET}
                        isDetailTicketPanel={true}
                    />
                    <DialogConfirmApproveRejectTicket
                        {...argsAll}
                        isOpen={isOpenPopupConfirmApproveRejectCustomerRequest}
                        setIsOpen={setIsOpenPopupConfirmApproveRejectCustomerRequest}
                        submitApproveReject={onSubmitApproveExternalCustomerRequest}
                    />
                    <DialogConfirmApproveRejectTicket
                        {...argsAll}
                        isOpen={isOpenPopupConfirmApproveRejectDeskRequest}
                        setIsOpen={setIsOpenPopupConfirmApproveRejectDeskRequest}
                        submitApproveReject={onSubmitApproveExternalDeskRequest}
                    />
                    <ConfirmForceEditTicket {...argsAll} />
                    <DialogNotificationTicketApprovedBefore
                        {...argsAll}
                        parentPanelScreen={Constant.PANEL_TYPE.DETAIL_TICKET}
                    />
                    <DataChangePleaseReloadModal
                        {...argsAll}
                        isOpen={isOpenModalApproveRejectError}
                        setIsOpen={setIsOpenModalApproveRejectError}
                    />
                    <DialogConfirmCreateTicketError
                        {...argsAll}
                        isOpen={isOpenPopupApproveRejectError}
                        setIsOpen={setIsOpenPopupApproveRejectError}
                        onSubmit={reloadPage}
                    />
                    <DialogConfirmChangeTicketError {...argsAll} isOpen={isOpenPopupEditError} />

                    <DialogConfirmSoftDeleteTicket
                        isOpen={isOpenPopupSoftDelete}
                        setIsOpen={setIsOpenPopupSoftDelete}
                        submitSoftDelete={submitSoftDelete}
                        detailTicket={detailTicket}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogRestoreTicket}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={
                            isRejectTicketAnonymous ? restoreAnonymousTicket : submitSoftDelete
                        }
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogBackToArrivalTicket}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-BACK-TO-NEW-SUPPORT')}
                        closeCallBack={onClickCloseConfirmDialogBackToArrival}
                        okCallBack={onClickOkConfirmDialogBackToArrival}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isConfirmDialogObj}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={onClickOkConfirmDialog}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenPopupTicketError}
                        okCallBack={handleReloadComponent}
                        msgConfirm={I18n.get('COMMSG068')}
                        textSubmit={I18n.get('COMBTN006')}
                    />
                    <DialogConfirmChangeTicketError {...argsAll} isOpen={isOpenPopupTicketMsg} />
                    <DataChangePleaseReloadModal
                        {...argsAll}
                        isOpen={isOpenModalReloadPage}
                        setIsOpen={setIsOpenModalReloadPage}
                        content={contentModalReloadPage}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogDeleteTicketFromLiveChat}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST')}
                        closeCallBack={() => setIsShowDialogDeleteTicketFromLiveChat(false)}
                        okCallBack={() => {
                            if (
                                Utils.isAnonymousQATicketFromLiveChat(detailTicket) &&
                                !detailTicket.deletedAt
                            ) {
                                setIsShowDialogDeleteTicketFromLiveChat(false);
                                submitSoftDelete();
                            } else {
                                handleDeleteCompleteTicketLiveChat(
                                    props?.API,
                                    setIsLoading,
                                    detailTicket,
                                    enqueueSnackbar,
                                    setCorporationDetail,
                                    closePanelTab,
                                    corporationDetail,
                                    props.panelId,
                                    props.ticketListType,
                                    props.panelType,
                                    props.tabId,
                                    setTriggerReloadTicket,
                                    panelList,
                                    setIsShowDialogDeleteTicketFromLiveChat,
                                    reloadTicketListByPanelType,
                                    setIsOpenModalReloadPage,
                                    currentProjectId,
                                    projectDetails
                                );
                            }
                        }}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenPopupKnowledgeOff}
                        msgConfirm={I18n.get('USER14MSG028')}
                        okCallBack={e => {
                            setIsOpenPopupKnowledgeOff(false);
                        }}
                        textSubmit={'はい'}
                    />
                    <ConfirmDialog
                        isOpen={isOpenAccessDeniedPopup}
                        msgConfirm={I18n.get('KNOWDEMSG005')}
                        okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenNotFoundTicketPopup}
                        msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                        okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={showPopupSingleButtonError?.isShow}
                        msgConfirm={showPopupSingleButtonError?.message}
                        okCallBack={e =>
                            setShowPopupSingleButtonError(pre => {
                                return {
                                    ...pre,
                                    isShow: false
                                };
                            })
                        }
                        textSubmit={showPopupSingleButtonError?.confirmTxt}
                    />
                    <ConfirmDialog
                        isOpen={isShowPopupLogout}
                        msgConfirm={
                            <div>
                                <span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span>
                                <br />
                                <span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span>
                            </div>
                        }
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                        okCallBack={() => signOut()}
                        cancelCallBack={() => setIsShowPopupLogout(false)}
                        cancelClassName={'btn-confirm-cancel'}
                    />
                    <ConfirmDialog
                        isOpen={displayPopupConfirmCancel}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                        okCallBack={() => {
                            setDisplayPopupConfirmCancel(false);
                            handleResetFormData();
                            setFlagReset(true);
                            setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                            saveFormData();
                        }}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        closeCallBack={() => setDisplayPopupConfirmCancel(false)}
                    />
                    <Popover
                        id={'show-more-options-popover'}
                        open={isOpenShowMoreOptionsPopover}
                        anchorEl={anchorShowMoreActionsPopover}
                        onClose={() => setAnchorShowMoreActionsPopover(null)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        style={{ marginLeft: -12 }}
                    >
                        
                        <div style={{ minWidth: 160 }} className="action-list-detail-ticket">
                            {(() => {
                                // Get allowed options cho telephone ticket
                                const isTelephoneTicket = detailTicket.ticketType === Constant.TICKET_TYPE.TELEPHONE;
                                let allowedOptions = null;
                                
                                if (isTelephoneTicket) {
                                    const isArchived = isDisplayButtonBackToArrival() && 
                                        getPanelType() !== Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
                                    const isDeleted = (isSoftDelete || isRejectTicketAnonymous) && 
                                        isGeneralUserWithGuest && 
                                        !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail);
                                    
                                    allowedOptions = getHamburgerMenuOptionsForTelephone(
                                        telephoneCallStatus,
                                        isArchived,
                                        isDeleted,
                                        isHelpdeskPanel
                                    );
                                }
                                
                                return (
                                    <>
                                        {/* Knowledge option - not displayed for telephone ticket */}
                                        {!isTelephoneTicket && isDisplayIconKnowledge(argsAll, projectIdListUserIsB2C) && (
                                            <Button variant="text" onClick={onOpenKnowledge}>
                                                <div className="content">
                                                    <img
                                                        className="icon"
                                                        src="/assets/image/icon-link.svg"
                                                        alt=""
                                                    />
                                                    <span className="text">{TooltipInKnowledge()}</span>
                                                </div>
                                            </Button>
                                        )}
                                        {/* Chat option */}
                                        {(!isTelephoneTicket || (allowedOptions && allowedOptions.includes('chat'))) && isDisplayIconChat(argsAll) && (
                                <Button variant="text" onClick={handleAddPanel}>
                                    <div className="content">
                                        <img
                                            className="icon"
                                            src="/assets/image/icon-chat.svg"
                                            alt=""
                                        />
                                        <span className="text">
                                            {I18n.get('helpdesk_chatThread')}
                                        </span>
                                    </div>
                                </Button>
                            )}
                            {/* Archive and Delete options */}
                            {!(
                                (isAnonymousQAWaitingTicket ||
                                    Utils.isAnonymousQAWaitingOrEndLiveChatTicket(detailTicket)) &&
                                detailTicket.customer === Constant.ANONYMOUS_USER_ID
                            ) &&
                                isDisplayButtonCluster() && (
                                    <>
                                        {/* Archive option */}
                                        {(!isTelephoneTicket || (allowedOptions && allowedOptions.includes('archive'))) &&
                                            isDisplayButtonArchivedTicket() &&
                                            getPanelType() !==
                                                Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL && (
                                                <Button
                                                    variant="text"
                                                    onClick={async () => {
                                                        await handleArchiveTicket(
                                                            props?.API,
                                                            detailTicket,
                                                            setDetailTicket,
                                                            reloadTicketListByPanelType,
                                                            getTicketListType(),
                                                            setTriggerReloadTicket,
                                                            currentUserDetail,
                                                            setTriggerReloadMenu,
                                                            argsAll
                                                        );
                                                        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                                                        setAnchorShowMoreActionsPopover(null);
                                                    }}
                                                    disabled={
                                                        Utils.isAnonymousQATicketFromLiveChat(
                                                            detailTicket
                                                        ) &&
                                                        !Utils.isAnonymousQAEndLiveChatTicket(
                                                            detailTicket
                                                        )
                                                    }
                                                >
                                                    <div className="content">
                                                        <img
                                                            className="icon"
                                                            src="/assets/image/icon-archive.svg"
                                                            alt=""
                                                        />
                                                        <span className="text">
                                                            {I18n.get('HELPDESK_ARCHIVE')}
                                                        </span>
                                                    </div>
                                                </Button>
                                            )}
                                        {/* Soft Delete option */}
                                        {(!isTelephoneTicket || (allowedOptions && allowedOptions.includes('delete'))) &&
                                            isDisplayButtonSoftDeleteTicket() && (
                                            <Button variant="text" onClick={handleSoftDeleteTicket}>
                                                <div className="content">
                                                    <img
                                                        className="icon"
                                                        src="/assets/image/icon-tabs-delete.svg"
                                                        alt=""
                                                    />
                                                    <span className="text">
                                                        {I18n.get('COMBTN013')}
                                                    </span>
                                                </div>
                                            </Button>
                                        )}
                                    </>
                                )}
                            {(!isTelephoneTicket || (allowedOptions && allowedOptions.includes('delete'))) &&
                                isDisableButtonSoftDeleteTicketQAAnonymos(detailTicket) && (
                                <Button variant="text" onClick={handleSoftDeleteTicket}>
                                    <div className="content">
                                        <img
                                            className="icon"
                                            src="/assets/image/icon-tabs-delete.svg"
                                            alt=""
                                        />
                                        <span className="text">{I18n.get('COMBTN013')}</span>
                                    </div>
                                </Button>
                            )}
                            {isDisplayButtonCompleteDeleteTicket(detailTicket) && (
                                <Button
                                    variant="text"
                                    disabled={isDisableButtonCompleteDeleteTicket(detailTicket)}
                                >
                                    <div className="content">
                                        <img
                                            className="icon"
                                            src="/assets/image/icon-tabs-delete.svg"
                                            alt=""
                                        />
                                        <span className="text">{I18n.get('COMBTN013')}</span>
                                    </div>
                                </Button>
                            )}
                            {/* Permanent Delete option */}
                            {(!isTelephoneTicket || (allowedOptions && allowedOptions.includes('permanentDelete'))) &&
                                (isSoftDelete || isRejectTicketAnonymous) &&
                                isGeneralUserWithGuest &&
                                !Utils.isDisabledTicketExternalWhenDeskServiceOff(
                                    detailTicket,
                                    corporationDetail
                                ) && (
                                    <Button
                                        variant="text"
                                        onClick={() => {
                                            setAnchorShowMoreActionsPopover(null);
                                            setIsConfirmDialogObj(true);
                                        }}
                                    >
                                        <div className="content">
                                            <img
                                                className="icon"
                                                src="/assets/image/icon-tabs-delete.svg"
                                                alt=""
                                            />
                                            <span className="text">{I18n.get('HARD_DELETE')}</span>
                                        </div>
                                    </Button>
                                )}
                                </>
                                );
                            })()}
                        </div>
                    </Popover>

                    <Popover
                        open={Boolean(openOption) || false}
                        anchorEl={openOption}
                        onClose={() => {
                            setOpenFileOption(null);
                            setOpenOption(null);
                        }}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            {openFileOption?.shortKey && (
                                <FlagMessageCopyLink
                                    title={I18n.get('KNOWDEMSG002')}
                                    placement="top-start"
                                    arrow={true}
                                    open={isShowFlagMessage}
                                >
                                    <ButtonOption onClick={onClickCopyShareLink}>
                                        <span
                                            style={{
                                                fontSize: 15,
                                                fontWeight: 400,
                                                fontFamily: 'Zen Kaku Gothic New'
                                            }}
                                        >
                                            {I18n.get('GET_URL')}
                                        </span>
                                    </ButtonOption>
                                </FlagMessageCopyLink>
                            )}
                        </div>
                    </Popover>

                    <Dialog
                        open={!!openPreviewImage}
                        onClose={() => setOpenPreviewImage(null)}
                        maxWidth="md"
                    >
                        <img
                            alt=""
                            src={openPreviewImage}
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain'
                            }}
                        />
                    </Dialog>
                </div>
            )}
        </div>
    );
}
